import { formatDate, CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, SecurityContext, inject, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { GoogleMapsModule, MapDirectionsService } from '@angular/google-maps';
import { ShipmentDeliveryAttachment } from '../models/shipment-delivery.attachment';
import { ShipmentDelivery } from '../models/delivery/shipment-delivery.model';
import { ShipmentDeliveryStop } from '../models/workflow/shipment-delivery-stop.model';
import { Shipment } from '../models/shipment';
import { SessionStorageService } from '../../services/session-storage.service';
import * as geoAddressHelpers from '../../helpers/geo-address.helper'
import { ConfirmationService, ConfirmEventType, MenuItem, MessageService } from 'primeng/api';
import { ShipmentStatus } from '../models/delivery/shipment-status';
import { ShipmentDeliveryJobStatus } from '../models/delivery/shipment-delivery-job-status';
import { ShipmentJobStatus } from '../models/delivery/shipment-job.status';
import { ReportsService } from '../../services/reports.service';
import { DialogService } from 'primeng/dynamicdialog';
import { ShipmentFileUploadComponent } from 'src/app/helpers/shipment-file-upload/shipment-file-upload.component';
import { ShipmentFileDownloadUrlCallback } from 'src/app/services/google/google-cloud-storage.service';
import { TransportationAgency } from "../../company/transportation-agency/transportation-agency.model";
import { AiSummaryService } from "../../services/ai-summary.service";
import { DomSanitizer } from "@angular/platform-browser";
import { ShipmentNomination } from "../models/nomination/shipment.nomination";
import { ShipmentNominationRole } from "../models/nomination/shipment-nomination-role.enum";
import { ShipmentChargeLine, ShipmentChargeLineBulkCreateRequest } from "../models/charge-line/shipment-charge-line";
import { ShipmentAccountsPostingResult, ShipmentConsolidation, ShipmentDeliveryReleaseAmendment, ShipmentPayloadLineCommandResult, ShipmentReleaseAttachmentPreview, ShipmentReleaseCandidate, ShipmentService, WaypointRouteSegment } from "../shipment.service";
import { ShipmentWaypoint } from '../models/waypoint/shipment.waypoint';
import { Location } from 'src/app/location/location.model';
import { Customer } from 'src/app/customer/customer.model';
import { CustomerService } from 'src/app/customer/customer.service';
import { environment } from 'src/environments/environment';
import { ShipmentDeliveryType } from "../models/delivery/shipment-delivery-type.model";
import { forkJoin, Observable, of, Subscription } from "rxjs";
import { catchError, concatMap, finalize, switchMap, tap } from "rxjs/operators";
import { GeoAddress } from 'src/app/models/common/geo-address.model';
import { fleetResourceAgencyLabel, fleetResourceOwnerLabel, fleetResourceOwnershipTypeLabel, fleetResourceSourceCompanyLabel } from 'src/app/shared/utils/fleet-resource-ownership.util';
import { ToastModule } from 'primeng/toast';
import { ProgressBarModule } from 'primeng/progressbar';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ToolbarModule } from 'primeng/toolbar';
import { TagModule } from 'primeng/tag';
import { FieldsetModule } from 'primeng/fieldset';
import { BadgeModule } from 'primeng/badge';
import { ImageModule } from 'primeng/image';
import { AvatarModule } from 'primeng/avatar';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ChipModule } from 'primeng/chip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { SelectModule } from 'primeng/select';
import { WaypointDialogComponent } from '../waypoint-dialog/waypoint-dialog.component';
import { ChargeLineDialogComponent } from '../charge-line-dialog/charge-line-dialog.component';
import { TabsModule } from 'primeng/tabs';
import { PermissionService } from '../../security/permission.service';
import { app_permissions } from '../../security/app-permissions';
import { Database, DataSnapshot, ListenEvent, ref, stateChanges } from '@angular/fire/database';
import { FormsModule } from '@angular/forms';
import { PageShellComponent } from '../../shared/page-layout/page-shell.component';
import { PageDetailHeroComponent } from '../../shared/page-layout/page-detail-hero.component';
import { PageMetricStripComponent } from '../../shared/page-layout/page-metric-strip.component';
import { PageDataPanelComponent } from '../../shared/page-layout/page-data-panel.component';
import { PageMetric } from '../../shared/page-layout/page-layout.models';
import { ShipmentRemark } from '../models/shipment-remark.model';
import { ShipmentRemarksFeed } from '../models/shipment-remarks-feed.model';
import { ShipmentWaybillSummary } from '../models/shipment-waybill-summary.model';
import { ShipmentDeliveryOperationStatus, ShipmentOperationTimelineEvent } from '../models/workflow/shipment-workflow.model';
import { WarehousingReturnRequest, WarehousingShipmentInboundRequest } from '../../warehousing/warehousing.model';
import { WarehousingService } from '../../warehousing/warehousing.service';
import { PayloadItemView } from '../../models/meta-params/payload-item-view';
import { PayloadType } from '../../models/meta-params/payload-type';
import { UOM } from '../../models/meta-params/uom';
import { Weight } from '../../models/meta-params/weight';
import { PayloadLineCommandDialogComponent } from '../../shared/payload-line-command-dialog/payload-line-command-dialog.component';
import { LocationService } from '../../location/location.service';
import { Driver } from '../../fleet/driver/driver.model';
import { ShipmentWaypointType } from '../models/waypoint/shipment-waypoint-type';
import { AuditStamp } from '../../shared/audit/audit.models';
import { DeliveryNoteLogisticsProject } from '../models/delivery-note-logistics-project';
import { TranslocoPipe } from '@jsverse/transloco';
import { LocaleService } from '../../i18n/locale.service';
import { ShipmentModePreferenceService } from '../simple-operations/shipment-mode-preference.service';
import { ExecutionSalesOrderButtonComponent } from '../../order/sales-order/execution-sales-order-button.component';
import { PayloadLedgerComponent, PayloadLedgerConfiguration } from '../payload-ledger/payload-ledger.component';
import { ShipmentDispatchDialogCommand, ShipmentDispatchDialogsComponent } from './dispatch-dialogs/shipment-dispatch-dialogs.component';
import { ShipmentDispatchCommand, ShipmentDispatchPanelComponent } from './dispatch/shipment-dispatch-panel.component';
import { formatShipmentDispatchStatus, ShipmentDispatchPresenter, ShipmentDispatchProgress } from './dispatch/shipment-dispatch.presenter';
import { ShipmentFinancialsCommand, ShipmentFinancialsPanelComponent } from './financials/shipment-financials-panel.component';
import { ShipmentFilesCommand, ShipmentFilesPanelComponent } from './files/shipment-files-panel.component';
import { ShipmentNotesCommand, ShipmentNotesPanelComponent } from './notes/shipment-notes-panel.component';
import { ShipmentPeopleCommand, ShipmentPeoplePanelComponent } from './people/shipment-people-panel.component';
import { ShipmentRouteCommand, ShipmentRoutePanelComponent } from './route/shipment-route-panel.component';
import { ShipmentCommercialPartyCorrectionComponent } from '../commercial-party-correction/shipment-commercial-party-correction.component';
import { PettyCashService, ShipmentCashRequest } from '../../accounts/workforce-cash/petty-cash.service';
import { ShipmentScheduleCorrectionComponent } from '../schedule-correction/shipment-schedule-correction.component';
import { ShipmentAccountsReviewDialogComponent } from '../accounts-posting-review/shipment-accounts-review-dialog.component';

const RETURN_WAYPOINT_REMARK = 'RETURN_TO_BASE';

@Component({
    selector: 'app-view-shipment',
    templateUrl: './view-shipment.component.html',
    styleUrls: ['../../shared/party-quick-create/party-quick-create-dialog.component.css',
        './view-shipment.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        ToastModule,
        RouterModule,
        ProgressBarModule,
        BreadcrumbModule,
        ToolbarModule,
        TagModule,
        FieldsetModule,
        TabsModule,
        BadgeModule,
        ImageModule,
        AvatarModule,
        TableModule,
        ButtonModule,
        SplitButtonModule,
        ChipModule,
        ConfirmDialogModule,
        TooltipModule,
        DialogModule,
        InputNumberModule,
        IftaLabelModule,
        InputGroupModule,
        InputGroupAddonModule,
        WaypointDialogComponent,
        ChargeLineDialogComponent,
        FormsModule,
        GoogleMapsModule,
        PageShellComponent,
        PageDetailHeroComponent,
        PageMetricStripComponent,
        PageDataPanelComponent,
        PayloadLineCommandDialogComponent,
        TranslocoPipe,
        ExecutionSalesOrderButtonComponent,
        PayloadLedgerComponent,
        ShipmentDispatchDialogsComponent,
        ShipmentDispatchPanelComponent,
        ShipmentFinancialsPanelComponent,
        ShipmentFilesPanelComponent,
        ShipmentPeoplePanelComponent,
        ShipmentNotesPanelComponent,
        ShipmentRoutePanelComponent,
        ShipmentCommercialPartyCorrectionComponent,
        ShipmentScheduleCorrectionComponent,
        ShipmentAccountsReviewDialogComponent
    ],
    providers: [ConfirmationService, MessageService, DialogService, ShipmentService, AiSummaryService, ReportsService, MapDirectionsService]
})
export class ViewShipmentComponent implements OnInit, OnDestroy {
    @ViewChild(ShipmentCommercialPartyCorrectionComponent) private partyCorrectionDialog?: ShipmentCommercialPartyCorrectionComponent;
    @ViewChild(ShipmentScheduleCorrectionComponent) private scheduleCorrectionDialog?: ShipmentScheduleCorrectionComponent;
    readonly routeWaypointDisplayType = this.waypointDisplayType.bind(this);
    readonly routeWaypointTypeSeverity = this.waypointTypeSeverity.bind(this);
    readonly routeWaypointMapsUrl = this.waypointGoogleMapsUrl.bind(this);
    readonly routeWaypointAddress = this.waypointShortAddress.bind(this);
    readonly routeWaypointSegmentDistance = this.waypointSegmentDistanceLabel.bind(this);
    readonly routeWaypointSegmentDuration = this.waypointSegmentDurationLabel.bind(this);

    protected readonly app_permissions = app_permissions;
    private readonly shipmentTabKeys = ['overview', 'route', 'dispatch', 'payload', 'financials', 'files', 'people', 'notes'] as const;
    get shipmentPayloadLedgerConfiguration(): PayloadLedgerConfiguration {
        const canMutate = !this.isCancelledShipment();
        return {
            title: 'Payload Lines',
            emptyDescription: 'This shipment has no payload details yet.',
            releaseRoutePrefix: '/transport-planning/releases',
            orchestrationRoutePrefix: '/transport-planning/orchestrations',
            allowMutations: canMutate,
            allowExtraction: canMutate
        };
    }
    private readonly localeService = inject(LocaleService);
    private readonly shipmentModePreference = inject(ShipmentModePreferenceService);
    private readonly pettyCash = inject(PettyCashService);
    private readonly dispatchPresenter = new ShipmentDispatchPresenter(value => this.showDate(value));

    shipmentId: number;
    private shipmentLoadRequestToken = 0;
    // Preserve a model instance when one of the parallel load requests fails
    // before its shipment response has been applied.
    shipment: Shipment = new Shipment();
    consolidation?: ShipmentConsolidation;
    consolidationLoading = false;
    consolidationError = false;
    releasePartyLabels: Record<number, string> = {};
    private liveJobStatusSubscription?: Subscription;
    orderDeliveryMap: Map<number, ShipmentDelivery> = new Map();
    shipmentJobMap: Map<number, ShipmentDelivery> = new Map();
    orderDeliveryList: ShipmentDelivery[] = [];
    deliveryRoutes: { deliveryNumber: string; stops: ShipmentDeliveryStop[] }[] = [];
    shipmentCashRequests: ShipmentCashRequest[] = [];
    shipmentCashError = false;
    orderJobList: ShipmentDelivery[] = [];
    waypointList: ShipmentWaypoint[] = [];
    waypointRouteSegments: WaypointRouteSegment[] = [];
    routeOverviewPolyline?: string;
    orderFilesList: ShipmentDeliveryAttachment[] = [];
    nominationEntities: ShipmentNomination[] = [];
    tripsCount: number = 0;
    jobsCount: number = 0;
    orderFilesCount: number = 0;
    isLoading: boolean = true;
    postingToAccounts: boolean = false;
    accountsReviewVisible = false;
    accountsPostingResult?: ShipmentAccountsPostingResult;
    requestedTruckCountDialogVisible = false;
    requestedTruckCountDraft?: number;
    requestedTruckCountSaving = false;
    requestedTruckCountError = '';
    private editDisabledNoticeShown = false;
    pickupSubLocality: string | undefined;
    dropoffSubLocality: string | undefined;
    pickupLocality: string | undefined;
    dropoffLocality: string | undefined;

    breadcrumbItems: MenuItem[];
    homeBreadcrumb: MenuItem;

    orderQueryStatus: ShipmentStatus = new ShipmentStatus();
    invokeDriverInProgress: boolean = false;
    confirmDriverInProgress: boolean = false;
    deliveryCancellationDialogVisible = false;
    deliveryCancellationInProgress = false;
    deliveryToCancel?: ShipmentDelivery;
    deliveryCancellationReason = '';
    releaseAmendmentDialogVisible = false;
    shipmentReleaseMode = false;
    releaseAmendmentStep: 1 | 2 | 3 = 1;
    releaseAmendmentLoading = false;
    releaseAmendmentApplying = false;
    releasePool: ShipmentReleaseCandidate[] = [];
    releaseSearch = '';
    releasePage = 0;
    releaseTotalPages = 0;
    releaseTotal = 0;
    releasePoolError = '';
    selectedReleaseIds: number[] = [];
    selectedDeliveryForAmendment?: ShipmentDelivery;
    releaseAmendmentPreview?: ShipmentDeliveryReleaseAmendment;
    shipmentAttachmentPreview?: ShipmentReleaseAttachmentPreview;
    releaseAmendmentHistory: ShipmentDeliveryReleaseAmendment[] = [];
    releaseAmendmentReason = '';
    releaseAmendmentBuyingPrice?: number;
    releaseAmendmentSellingPrice?: number;
    showAddFileDialog: boolean = false;
    currentTransportationAgency: TransportationAgency | null;
    shipmentAiSummary: string | null = '';
    // Component properties
    chargeLineDialogVisible: boolean = false;
    selectedChargeLine: ShipmentChargeLine;
    saveChargeLineInProgress: boolean = false;
    chargeTypeToBeUpdated: string = '';
    updateChargesDialogVisible: boolean = false;
    updatedCharge: number = 0;
    updateChargesDialogHeader: string = '';
    updateChargesInProgress: boolean = false;
    tripCostRefreshKey: number = 0;
    addWatcherDialogVisible = false;
    watcherContactOptions: Customer[] = [];
    selectedWatcher?: Customer;
    watcherOptionsLoading = false;
    addWatcherInProgress = false;
    shipmentRemark: ShipmentRemark = {};
    shipmentRemarksHtml = '';
    shipmentRemarksFeed: ShipmentRemarksFeed = { entries: [] };
    shipmentWaybillSummary: ShipmentWaybillSummary = { deliveries: [] };
    shipmentRouteSegmentsLoading = false;
    shipmentRouteSegmentsError = false;
    shipmentNotesLoading = false;
    shipmentNotesError = false;
    shipmentWaybillsLoading = false;
    shipmentWaybillsError = false;
    saveShipmentRemarksInProgress = false;
    payloadExtractionInProgress = false;
    payloadTypes: PayloadType[] = [];
    uomList: UOM[] = [];
    weightUnitList: Weight[] = [];
    private deliveryOperationStatusById: Record<number, ShipmentDeliveryOperationStatus> = {};

    deliveryOperationStatuses(): Record<number, ShipmentDeliveryOperationStatus> {
        return this.deliveryOperationStatusById;
    }

    // Waypoint Dialog properties
    addWaypointDialogVisible = false;
    newWaypoint: ShipmentWaypoint;
    waypointDialogMode: 'create' | 'edit-location' = 'create';
    waypointDialogPurpose: 'standard' | 'return' = 'standard';
    selectedWaypointForLocationEdit?: ShipmentWaypoint;
    waypointTypeOptions: any[];
    addWaypointInProgress = false;
    submittedWaypoint = false;
    insertAfterSequence = 0;
    manualWaypointOrderMode = false;
    waypointOrderDirty = false;
    waypointOrderSaveInProgress = false;
    private waypointOrderSnapshot: ShipmentWaypoint[] = [];
    googleMapsApiKey = environment.googleApiKey;
    companyLocations: Location[] = [];

    private route = inject(ActivatedRoute);
    private sanitizer = inject(DomSanitizer);
    private router = inject(Router);
    private aiSummaryService = inject(AiSummaryService);
    private database = inject(Database);
    private cdr = inject(ChangeDetectorRef);
    protected sessionStorageService = inject(SessionStorageService);
    private messageService = inject(MessageService);
    private confirmationService = inject(ConfirmationService);
    private shipmentService = inject(ShipmentService);
    private warehousingService = inject(WarehousingService);
    returnWarehouseBlockers: WarehousingReturnRequest[] = [];
    shipmentInboundRequests: WarehousingShipmentInboundRequest[] = [];
    private customerService = inject(CustomerService);
    private locationService = inject(LocationService);
    private mapDirectionsService = inject(MapDirectionsService);
    private dialogService = inject(DialogService);
    private reportsService = inject(ReportsService);
    public permissionService = inject(PermissionService);

    constructor() {
        this.currentTransportationAgency = this.sessionStorageService.getTransportationAgency();
        this.payloadTypes = this.sessionStorageService.getPayloadTypes() ?? [];
        this.uomList = this.sessionStorageService.getUOMList() ?? [];
        this.weightUnitList = this.sessionStorageService.getWeightUnits() ?? [];
    }

    ngOnInit(): void {
        this.route.params.subscribe((params: any) => {
            this.shipmentId = params['shipmentId'] as unknown as number;
            this.getOrderQuery();
        });
        this.route.queryParamMap.subscribe(queryParams => {
            this.activeTabIndex = this.resolveShipmentTabIndex(queryParams.get('tab'));
            if (!this.editDisabledNoticeShown && queryParams.get('editingDisabled') === 'true') {
                this.editDisabledNoticeShown = true;
                this.messageService.add({
                    severity: 'info',
                    summary: 'Shipment editing disabled',
                    detail: 'Shipment plans are read-only. Use an approved adjustment action for a correction.'
                });
            }
            this.cdr.markForCheck();
        });
        this.waypointTypeOptions = [
            { label: 'Pickup', value: 'PICKUP' },
            { label: 'Dropoff', value: 'DROPOFF' }
        ];
    }

    ngOnDestroy(): void {
        this.liveJobStatusSubscription?.unsubscribe();
    }

    switchToSimpleMode(): void {
        this.shipmentModePreference.set('SIMPLE');
        this.router.navigate(['/shipment/view', this.shipmentId, 'simple']);
    }

    shipmentMetrics(): PageMetric[] {
        const currency = this.shipment?.countryOfOrder?.currencyCode ?? '';
        const quantity = this.shipment?.quantityRequired ?? 0;
        const chargeBuyingTotal = (this.shipment?.chargeLines ?? [])
            .reduce((sum, line) => sum + (line.buyingChargeAmount ?? 0), 0);
        const buying = chargeBuyingTotal || (this.shipment?.buyingPrice ?? 0) * quantity;
        const selling = this.shipment?.sellingPrice ?? 0;
        const deliveryCount = this.orderDeliveryList.length + this.orderJobList.length;

        const metrics: PageMetric[] = [];
        if (this.canViewShipmentPricing()) {
            metrics.push({
                label: this.localeService.translate('pages.shipmentDetail.metrics.buyingTotal'),
                value: this.formatAmount(currency, buying),
                hint: chargeBuyingTotal > 0
                    ? 'Delivery and charge-line costs'
                    : `${quantity} x ${this.formatAmount(currency, this.shipment?.buyingPrice ?? 0)}`,
                tone: 'danger'
            });
            metrics.push({
                label: this.localeService.translate('pages.shipmentDetail.metrics.sellingTotal'),
                value: this.formatAmount(currency, selling * quantity),
                hint: this.isZeroSellConsolidation() ? 'Shipment-level zero sell; clients are shown below'
                    : `${quantity} x ${this.formatAmount(currency, selling)}`,
                tone: 'success'
            });
        }
        metrics.push(
            {
                label: this.localeService.translate('pages.shipmentDetail.metrics.deliveries'),
                value: deliveryCount,
                hint: this.localeService.translate('pages.shipmentDetail.metrics.deliveriesHint', {
                    trips: this.tripsCount,
                    jobs: this.jobsCount
                }),
                tone: 'info'
            },
            {
                label: this.localeService.translate('pages.shipmentDetail.metrics.files'),
                value: this.orderFilesCount,
                hint: this.localeService.translate('pages.shipmentDetail.metrics.filesHint'),
                tone: 'default'
            }
        );
        return metrics;
    }

    canViewShipmentPricing(): boolean {
        return this.permissionService.hasPermission(app_permissions.shipments.pricing.view);
    }

    private formatAmount(currency: string, value: number): string {
        const prefix = currency ? `${currency} ` : '';
        return `${prefix}${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }

    canChangeRequestedTruckCount(): boolean {
        if (!this.shipmentId || this.isCancelledShipment() || this.isPostedToAccounts()) return false;
        const status = String(this.shipment?.shipmentStatus || '').toUpperCase();
        return status !== 'COMPLETED' && this.permissionService.hasPermission(app_permissions.shipments.edit);
    }

    minimumRequestedTruckCount(): number {
        return Math.max(1, this.orderJobList.length + this.orderDeliveryList.length);
    }

    openRequestedTruckCountDialog(): void {
        if (!this.canChangeRequestedTruckCount()) return;
        this.requestedTruckCountDraft = Math.max(this.shipment?.quantityRequired || 1, this.minimumRequestedTruckCount());
        this.requestedTruckCountError = '';
        this.requestedTruckCountDialogVisible = true;
    }

    closeRequestedTruckCountDialog(): void {
        if (this.requestedTruckCountSaving) return;
        this.requestedTruckCountDialogVisible = false;
        this.requestedTruckCountDraft = undefined;
        this.requestedTruckCountError = '';
    }

    saveRequestedTruckCount(): void {
        const requestedTruckCount = Math.trunc(Number(this.requestedTruckCountDraft));
        const minimum = this.minimumRequestedTruckCount();
        if (!Number.isFinite(requestedTruckCount) || requestedTruckCount < minimum) {
            this.requestedTruckCountError = `Enter at least ${minimum} truck${minimum === 1 ? '' : 's'} to preserve existing assignments.`;
            return;
        }

        this.requestedTruckCountError = '';
        this.requestedTruckCountSaving = true;
        this.shipmentService.updateRequestedTruckCount(this.shipmentId, requestedTruckCount).subscribe({
            next: () => {
                this.requestedTruckCountSaving = false;
                this.requestedTruckCountDialogVisible = false;
                this.requestedTruckCountDraft = undefined;
                this.requestedTruckCountError = '';
                this.messageService.add({
                    severity: 'success',
                    summary: 'Requested trucks updated',
                    detail: `The shipment now requests ${requestedTruckCount} truck${requestedTruckCount === 1 ? '' : 's'}.`
                });
                this.getOrderQuery();
            },
            error: error => {
                this.requestedTruckCountSaving = false;
                this.requestedTruckCountError = error?.error?.detail || error?.error?.message
                    || 'Could not update the requested truck count.';
                this.cdr.markForCheck();
            }
        });
    }

    hasLogisticsProject(): boolean {
        return this.includedLogisticsProjects().length > 0;
    }

    logisticsProjectRoute(): any[] {
        return ['/logistics-projects', this.primaryLogisticsProjectId()];
    }

    hasMultipleLogisticsProjects(): boolean {
        return this.includedLogisticsProjects().length > 1;
    }

    logisticsProjectTagLabel(): string {
        const projects = this.includedLogisticsProjects();
        if (projects.length > 1) {
            return `${projects.length} Projects`;
        }
        const project = projects[0];
        return project?.projectNumber || (project?.projectId ? `Project #${project.projectId}` : 'Project');
    }

    logisticsProjectMenuItems(): MenuItem[] {
        return this.includedLogisticsProjects().map(project => ({
            label: this.logisticsProjectLabel(project),
            icon: 'fa-solid fa-briefcase',
            command: () => this.openLogisticsProject(project.projectId)
        }));
    }

    openPrimaryLogisticsProject(): void {
        this.openLogisticsProject(this.primaryLogisticsProjectId());
    }

    private openLogisticsProject(projectId?: number): void {
        if (!projectId) {
            return;
        }
        this.router.navigate(['/logistics-projects', projectId]);
    }

    private primaryLogisticsProjectId(): number | undefined {
        return this.includedLogisticsProjects()[0]?.projectId || this.shipment?.logisticsProjectId;
    }

    private includedLogisticsProjects(): DeliveryNoteLogisticsProject[] {
        const included = (this.shipment?.includedLogisticsProjects ?? [])
            .filter(project => !!project?.projectId);
        if (included.length > 0) {
            return included;
        }
        return this.shipment?.logisticsProjectId ? [{ projectId: this.shipment.logisticsProjectId }] : [];
    }

    private logisticsProjectLabel(project?: DeliveryNoteLogisticsProject): string {
        const name = project?.projectName || project?.projectNumber || (project?.projectId ? `Project #${project.projectId}` : 'Project');
        return project?.createdByCustomerName ? `${name} - ${project.createdByCustomerName}` : name;
    }

    fulfillmentPercent(): number {
        const requested = this.shipment?.quantityRequired || 0;
        if (requested === 0) return 0;
        return Math.min(100, Math.round((this.tripsCount / requested) * 100));
    }

    remainingAssignments(): number {
        return Math.max((this.shipment?.quantityRequired || 0) - this.tripsCount - this.jobsCount, 0);
    }

    routeDistanceLabel(): string {
        const segmentDistance = (this.waypointRouteSegments ?? [])
            .reduce((sum, segment) => sum + (segment.distanceKm ?? 0), 0);
        if (segmentDistance > 0) {
            return `${segmentDistance.toLocaleString('en-US', { maximumFractionDigits: 1 })} km`;
        }
        if (!this.shipment?.distance) return 'Not calculated';
        return `${(this.shipment.distance / 1000).toLocaleString('en-US', { maximumFractionDigits: 1 })} km`;
    }

    routeDurationLabel(): string {
        const segmentDuration = (this.waypointRouteSegments ?? [])
            .reduce((sum, segment) => sum + (segment.durationSeconds ?? 0), 0);
        if (segmentDuration > 0) {
            return this.formatDurationSeconds(segmentDuration);
        }
        if (!this.shipment?.time) return 'Not calculated';
        return this.formatDurationSeconds(this.shipment.time);
    }

    pickupScheduleLabel(): string {
        return this.scheduleDateLabel(this.shipment?.pickupTime ?? this.shipment?.requestedBookingTime);
    }

    deliveryScheduleLabel(): string {
        return this.scheduleDateLabel(this.shipment?.dropoffTime);
    }

    priorityLabel(): string {
        return this.formatStatusLabel(this.shipment?.priority || 'NORMAL');
    }

    serviceCategoryLabel(): string {
        switch (String(this.shipment?.serviceCategory || 'FULL_SERVICE').toUpperCase()) {
            case 'LCL': return 'LCL — Less than Container Load';
            case 'FCL': return 'FCL — Full Container Load';
            case 'LTL': return 'LTL — Less than Truckload';
            case 'FTL': return 'FTL — Full Truckload';
            default: return this.formatStatusLabel(this.shipment?.serviceCategory || 'FULL_SERVICE');
        }
    }

    prioritySeverity(): string {
        switch (String(this.shipment?.priority || 'NORMAL').toUpperCase()) {
            case 'CRITICAL': return 'danger';
            case 'HIGH': return 'warn';
            default: return 'secondary';
        }
    }

    waypointSegment(index: number): WaypointRouteSegment | undefined {
        return (this.waypointRouteSegments ?? []).find(segment => Number(segment.sequence) === index + 1);
    }

    waypointSegmentDistanceLabel(index: number): string {
        const distanceKm = this.waypointSegment(index)?.distanceKm;
        if (distanceKm == null) return 'Distance pending';
        return `${distanceKm.toLocaleString('en-US', { maximumFractionDigits: 1 })} km`;
    }

    waypointSegmentDurationLabel(index: number): string {
        const durationSeconds = this.waypointSegment(index)?.durationSeconds;
        if (durationSeconds == null) return 'Time pending';
        return this.formatDurationSeconds(durationSeconds);
    }

    private formatDurationSeconds(durationSeconds: number): string {
        const totalMinutes = Math.max(1, Math.round(durationSeconds / 60));
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        if (hours === 0) return `${minutes} min`;
        return `${hours}h ${minutes}m`;
    }

    intermediateWaypointCount(): number {
        return Math.max((this.waypointList?.length ?? 0) - 2, 0);
    }

    showRouteEndpointBoard(): boolean {
        return (this.waypointList?.length ?? 0) <= 2;
    }

    showRouteSummaryCards(): boolean {
        return (this.waypointList?.length ?? 0) > 2;
    }

    waypointTypeCount(type: string): number {
        if (type === 'CROSS_DOCK') {
            return (this.waypointList ?? []).filter(waypoint => this.isCrossDockWaypoint(waypoint)).length;
        }
        if (type === 'DROPOFF') {
            return (this.waypointList ?? []).filter(waypoint => this.isDropoffWaypoint(waypoint) && !this.isCrossDockWaypoint(waypoint)).length;
        }
        return (this.waypointList ?? []).filter(waypoint => waypoint.waypointType === type).length;
    }

    waypointDisplayType(waypoint: ShipmentWaypoint): string {
        if (!waypoint) return 'Stop';
        if (this.isReturnWaypoint(waypoint)) return 'Driver Return';
        if (this.isPrimaryPickupWaypoint(waypoint)) return 'Primary Pickup';
        if (this.isCrossDockWaypoint(waypoint)) return 'Cross Dock';
        if (this.isFinalDropoffWaypoint(waypoint)) return 'Final Dropoff';
        if (waypoint.waypointType === 'PICKUP') return `Secondary Pickup #${this.secondaryWaypointIndex(waypoint, 'PICKUP')}`;
        if (this.isDropoffWaypoint(waypoint)) return `Secondary Dropoff #${this.secondaryWaypointIndex(waypoint, 'DROPOFF')}`;
        return this.formatStatusLabel(waypoint.waypointType);
    }

    waypointContact(waypoint: ShipmentWaypoint): Customer | undefined {
        if (this.isPrimaryPickupWaypoint(waypoint)) {
            return this.shipment?.nominationPack?.sender?.nominee;
        }
        if (this.isFinalDropoffWaypoint(waypoint)) {
            return this.shipment?.nominationPack?.receiver?.nominee;
        }
        return waypoint?.location?.defaultContact;
    }

    waypointContactCompany(waypoint: ShipmentWaypoint): string {
        if (this.isPrimaryPickupWaypoint(waypoint)) {
            return this.shipment?.nominationPack?.sender?.client?.name || 'Sender company pending';
        }
        if (this.isFinalDropoffWaypoint(waypoint)) {
            return this.shipment?.nominationPack?.receiver?.client?.name || 'Receiver company pending';
        }
        return waypoint?.location?.company?.name
            || waypoint?.location?.managedBy?.name
            || 'Company not assigned';
    }

    waypointPhone(waypoint: ShipmentWaypoint): string {
        return this.waypointContact(waypoint)?.phoneNumber
            || waypoint?.location?.telephoneNumber
            || 'Not available';
    }

    shipmentCompanyLabel(): string {
        return this.shipment?.company?.name
            || (this.shipment?.company?.id ? `Company #${this.shipment.company.id}` : 'Customer company pending');
    }

    shipmentCustomerLabel(): string {
        return this.shipment?.customer?.name
            || this.shipment?.customer?.emailAddress
            || this.shipment?.customer?.phoneNumber
            || (this.shipment?.customer?.id ? `Customer #${this.shipment.customer.id}` : 'Customer contact pending');
    }

    shipmentOwningContactLabel(): string {
        return this.shipment?.owningCompanyContact?.name
            || this.shipment?.owningCompanyContact?.emailAddress
            || this.shipment?.owningCompanyContact?.phoneNumber
            || (this.shipment?.owningCompanyContact?.id ? `Contact #${this.shipment.owningCompanyContact.id}` : 'Creator contact pending');
    }

    shipmentAuditStamp(): AuditStamp {
        return {
            showWhenEmpty: true,
            createdAt: this.shipment?.createdAt,
            createdBy: this.shipment?.createdBy,
            createdByActor: this.shipment?.createdByActor,
            updatedAt: this.shipment?.updatedAt,
            updatedBy: this.shipment?.updatedBy,
            updatedByActor: this.shipment?.updatedByActor,
        };
    }

    shipmentCrmClientLabel(): string {
        return this.shipment?.crmClientName
            || (this.shipment?.crmClientId ? `CRM Client #${this.shipment.crmClientId}` : 'CRM client pending');
    }

    shipmentCrmAccountLabel(): string {
        return this.shipment?.crmAccountName
            || (this.shipment?.crmAccountId ? `CRM Account #${this.shipment.crmAccountId}` : 'CRM account pending');
    }

    shipmentCrmClientContactLabel(): string {
        return this.shipment?.crmClientContactName
            || (this.shipment?.crmClientContactId ? `CRM Contact #${this.shipment.crmClientContactId}` : 'CRM contact pending');
    }

    hasCrmCommercialContext(): boolean {
        return Boolean(
            this.shipment?.crmClientId
            || this.shipment?.crmClientName
            || this.shipment?.crmAccountId
            || this.shipment?.crmAccountName
            || this.shipment?.crmClientContactId
            || this.shipment?.crmClientContactName
        );
    }

    hasCrmAccountContext(): boolean {
        return Boolean(this.shipment?.crmAccountId || this.shipment?.crmAccountName);
    }

    shipmentKamLabel(): string {
        return this.shipment?.kamCustomerName
            || (this.shipment?.kamCustomerId ? `KAM #${this.shipment.kamCustomerId}` : 'KAM pending');
    }

    waypointShortAddress(waypoint: ShipmentWaypoint): string {
        return this.getShortAddress(waypoint?.location?.address) || waypoint?.location?.shortDescription || 'Address not available';
    }

    waypointScheduleLabel(waypoint: ShipmentWaypoint): string {
        const scheduledArrival = this.formatWaypointDate(waypoint?.scheduledArrival);
        const scheduledDeparture = this.formatWaypointDate(waypoint?.scheduledDeparture);
        if (scheduledArrival && scheduledDeparture) return `${scheduledArrival} to ${scheduledDeparture}`;
        if (scheduledArrival) return `Arrival ${scheduledArrival}`;
        if (scheduledDeparture) return `Departure ${scheduledDeparture}`;
        return 'Schedule pending';
    }

    waypointTypeSeverity(waypoint: ShipmentWaypoint): string {
        if (this.isReturnWaypoint(waypoint)) return 'warning';
        if (this.isCrossDockWaypoint(waypoint)) return 'warn';
        switch (waypoint?.waypointType) {
            case 'PICKUP':
                return 'info';
            case 'DROPOFF':
                return 'success';
            default:
                return 'secondary';
        }
    }

    isReturnWaypoint(waypoint?: ShipmentWaypoint): boolean {
        return String(waypoint?.remarks || '').toUpperCase().includes(RETURN_WAYPOINT_REMARK);
    }

    hasReturnWaypoint(): boolean {
        return (this.waypointList ?? []).some(waypoint => this.isReturnWaypoint(waypoint));
    }

    returnWaypointComplete(): boolean {
        const returnWaypoints = (this.waypointList ?? []).filter(waypoint => this.isReturnWaypoint(waypoint));
        if (returnWaypoints.length === 0) return false;
        return returnWaypoints.every(waypoint => this.returnWaypointStopComplete(waypoint));
    }

    returnWaypointStatusLabel(): string {
        if (!this.hasReturnWaypoint()) return 'Optional return stop not added';
        return this.returnWaypointComplete() ? 'Return completed' : 'Return pending';
    }

    returnWaypointStatusSeverity(): string {
        if (!this.hasReturnWaypoint()) return 'secondary';
        return this.returnWaypointComplete() ? 'success' : 'warning';
    }

    primaryAssignedDriver(): Driver | undefined {
        return (this.orderDeliveryList ?? []).find(delivery => delivery.deliveryDriver)?.deliveryDriver
            ?? (this.orderJobList ?? []).find(delivery => delivery.deliveryDriver)?.deliveryDriver;
    }

    driverResidenceLabel(): string {
        const driver = this.primaryAssignedDriver();
        if (driver?.homeLocation?.name) {
            return driver.homeLocation.name;
        }
        const city = driver?.residingCity?.cityName;
        const country = driver?.residingCountry?.name ?? driver?.residingCity?.country?.name;
        if (!driver) return 'No confirmed driver';
        if (city && country) return `${city}, ${country}`;
        return city || country || 'Residence not configured';
    }

    canAddDriverResidenceReturnWaypoint(): boolean {
        if (this.isCancelledShipment()) return false;
        const driver = this.primaryAssignedDriver();
        if (driver?.homeLocation?.id) return true;
        const coordinates = driver?.residingCity?.coordinates ?? driver?.preferredLocation;
        return Boolean(driver?.residingCity && coordinates?.latitude != null && coordinates?.longitude != null);
    }

    private returnWaypointStopComplete(waypoint: ShipmentWaypoint): boolean {
        const deliveryStatuses = Object.values(this.deliveryOperationStatusById ?? {});
        const syncedStops = deliveryStatuses
            .flatMap(status => status?.stops ?? [])
            .filter(stop => Number(stop?.stopNumber) === Number(waypoint.waypointNumber));
        if (syncedStops.length > 0) {
            return syncedStops.every(stop => this.isCompleteOrSkipped(stop.workflowState));
        }
        return this.isCompleteOrSkipped(waypoint.status);
    }

    private isCompleteOrSkipped(status?: string): boolean {
        const normalized = String(status || '').toUpperCase();
        return normalized === 'COMPLETE' || normalized === 'COMPLETED' || normalized === 'SKIPPED';
    }

    openReturnWaypointLocationDialog(): void {
        if (this.hasReturnWaypoint()) {
            this.messageService.add({ severity: 'info', summary: 'Return waypoint exists', detail: 'This shipment already has a driver return waypoint.' });
            return;
        }
        this.waypointDialogMode = 'create';
        this.waypointDialogPurpose = 'return';
        this.selectedWaypointForLocationEdit = undefined;
        this.insertAfterSequence = this.waypointList?.length ?? 0;
        this.newWaypoint = this.buildReturnWaypoint(this.primaryAssignedDriver()?.homeLocation);
        this.addWaypointDialogVisible = true;
    }

    addReturnWaypointToDriverResidence(): void {
        if (this.hasReturnWaypoint()) {
            this.messageService.add({ severity: 'info', summary: 'Return waypoint exists', detail: 'This shipment already has a driver return waypoint.' });
            return;
        }

        const driver = this.primaryAssignedDriver();
        if (driver?.homeLocation?.id) {
            this.addWaypointInProgress = true;
            this.shipmentService.createWaypoint(this.shipmentId, this.buildReturnWaypoint(driver.homeLocation)).pipe(
                finalize(() => {
                    this.addWaypointInProgress = false;
                    this.cdr.markForCheck();
                })
            ).subscribe({
                next: () => {
                    this.messageService.add({ severity: 'success', summary: 'Return waypoint added', detail: 'Driver home location added to the route.' });
                    this.resetManualWaypointOrder();
                    this.getOrderQuery();
                },
                error: () => {
                    this.messageService.add({ severity: 'error', summary: 'Return waypoint failed', detail: 'Could not add driver home location.' });
                }
            });
            return;
        }

        const coordinates = driver?.residingCity?.coordinates ?? driver?.preferredLocation;
        if (!driver || !driver.residingCity || coordinates?.latitude == null || coordinates?.longitude == null) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Driver residence unavailable',
                detail: 'Assign a driver with a home location or residing city coordinates, or select a return location manually.'
            });
            return;
        }

        const company = this.sessionStorageService.getCompany();
        if (!company?.id) {
            this.messageService.add({ severity: 'error', summary: 'Company missing', detail: 'Current company context is required to create a return location.' });
            return;
        }

        const cityName = driver.residingCity.cityName;
        const country = driver.residingCountry ?? driver.residingCity.country;
        const driverName = driver.legalName || driver.name || `Driver ${driver.id}`;
        const location = {
            name: `${driverName} return - ${cityName}`,
            shortDescription: `Driver return to ${cityName}`,
            longDescription: `Driver return waypoint for ${driverName} at ${cityName}${country?.name ? ', ' + country.name : ''}`,
            locationType: 'DRIVER_RETURN',
            cityId: driver.residingCity.id,
            countryId: country?.id,
            country,
            company,
            managedBy: company,
            location: coordinates,
            telephoneNumber: driver.phoneNumber ?? null,
            externalLocationReference: `RET-${this.shipmentId}-${driver.id || 'DRIVER'}-${driver.residingCity.id}-${Date.now()}`
        } as Location;

        this.addWaypointInProgress = true;
        this.locationService.createLocation(location).pipe(
            switchMap(response => {
                if (!response?.success || !response.data?.id) {
                    throw new Error(response?.message || 'Return location could not be created.');
                }
                return this.shipmentService.createWaypoint(this.shipmentId, this.buildReturnWaypoint(response.data));
            }),
            finalize(() => {
                this.addWaypointInProgress = false;
                this.cdr.markForCheck();
            })
        ).subscribe({
            next: () => {
                this.messageService.add({ severity: 'success', summary: 'Return waypoint added', detail: 'Driver residence return stop added to the route.' });
                this.resetManualWaypointOrder();
                this.getOrderQuery();
            },
            error: (error: any) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Return waypoint failed',
                    detail: error?.message || 'Could not add driver residence return stop.'
                });
            }
        });
    }

    private operationStatusFor(job: ShipmentDelivery): ShipmentDeliveryOperationStatus | undefined {
        if (!job?.deliveryId) {
            return undefined;
        }
        return this.deliveryOperationStatusById[job.deliveryId];
    }

    isCancelledShipment(): boolean {
        const status = String(this.shipment?.workflowState || this.shipment?.shipmentStatus || '').toUpperCase();
        return status === 'CANCELLED';
    }

    isPostedToAccounts(): boolean {
        const status = String(this.shipment?.workflowState || this.shipment?.shipmentStatus || '').toUpperCase();
        return ['POSTED_TO_ACCOUNTS', 'INVOICED', 'CLOSED'].includes(status);
    }

    canShowCommercialAction(): boolean {
        if (!this.shipment || this.isCancelledShipment() || this.isPostedToAccounts()) {
            return false;
        }
        return this.permissionService.hasPermission(app_permissions.order.records.create);
    }

    isCompletedDelivery(delivery: ShipmentDelivery): boolean {
        const workflow = String(delivery?.workflowState || '').toUpperCase();
        const status = String(delivery?.jobStatus || '').toUpperCase();
        return ['DELIVERY_COMPLETE', 'CUSTOMER_ACKNOWLEDGED'].includes(workflow)
            || ['DRIVER_JOB_COMPLETED', 'JOB_COMPLETION_ACKNOWLEDGE'].includes(status);
    }

    private isCancelledDelivery(delivery: ShipmentDelivery): boolean {
        const workflow = String(delivery?.workflowState || '').toUpperCase();
        const status = String(delivery?.jobStatus || '').toUpperCase();
        const statusHistory = Object.keys(delivery?.jobStatusMap ?? {}).map(value => value.toUpperCase());
        return workflow === 'CANCELLED'
            || ['JOB_DRIVER_CANCELLED', 'JOB_DRIVER_REJECTED', 'JOB_CANCELLED'].includes(status)
            || statusHistory.some(value => ['JOB_DRIVER_CANCELLED', 'JOB_DRIVER_REJECTED', 'JOB_CANCELLED'].includes(value));
    }

    getCancellableDeliveries(): ShipmentDelivery[] {
        const map = new Map<number, ShipmentDelivery>();
        const allDeliveries = [
            ...(this.shipment?.deliveries || []),
            ...this.orderDeliveryList,
            ...this.orderJobList
        ];
        for (const delivery of allDeliveries) {
            if (delivery?.deliveryId && !map.has(delivery.deliveryId)) {
                if (!this.isCancelledDelivery(delivery) && !this.isCompletedDelivery(delivery)) {
                    map.set(delivery.deliveryId, delivery);
                }
            }
        }
        return Array.from(map.values());
    }

    deliveryProgress(job: ShipmentDelivery): ShipmentDispatchProgress {
        return this.dispatchPresenter.deliveryProgress(job, this.deliveryOperationStatusById);
    }

    getDriverName(job: ShipmentDelivery): string {
        return this.dispatchPresenter.driverName(job);
    }

    getVehicleLabel(job: ShipmentDelivery): string {
        return this.dispatchPresenter.vehicleLabel(job);
    }

    getJobUpdatedAt(job: ShipmentDelivery): string {
        return this.dispatchPresenter.updatedAt(job, this.deliveryOperationStatusById);
    }

    formatStatusLabel(status: string | undefined): string {
        return formatShipmentDispatchStatus(status);
    }

    shipmentHeroStatusClass(): string {
        const status = String(this.shipment?.workflowState || this.shipment?.shipmentStatus || 'DRAFT').toUpperCase();
        switch (status) {
            case 'IN_PROGRESS':
                return 'status-in-progress';
            case 'COMPLETED':
            case 'POSTED_TO_ACCOUNTS':
            case 'CLOSED':
                return 'status-complete';
            case 'CANCELLED':
                return 'status-cancelled';
            case 'DRAFT':
                return 'status-draft';
            default:
                return 'status-default';
        }
    }

    shipmentHeroStatusIcon(): string {
        const status = String(this.shipment?.workflowState || this.shipment?.shipmentStatus || 'DRAFT').toUpperCase();
        switch (status) {
            case 'IN_PROGRESS':
                return 'fa-solid fa-circle-play';
            case 'COMPLETED':
            case 'POSTED_TO_ACCOUNTS':
            case 'CLOSED':
                return 'fa-solid fa-circle-check';
            case 'CANCELLED':
                return 'fa-solid fa-circle-xmark';
            case 'DRAFT':
                return 'fa-solid fa-pen-to-square';
            default:
                return 'fa-solid fa-circle-info';
        }
    }

    cashRequestForDelivery(deliveryId?: number): ShipmentCashRequest | undefined {
        return this.shipmentCashRequests.find(request => request.deliveryid === deliveryId);
    }

    retryShipmentCashRequests(): void {
        this.loadShipmentCashRequests(Number(this.shipmentId), this.shipmentLoadRequestToken);
    }

    private loadShipmentCashRequests(shipmentId: number, requestToken: number): void {
        const companyId = this.shipment?.owningCompany?.id ?? this.sessionStorageService.getCompany()?.id;
        this.shipmentCashRequests = [];
        this.shipmentCashError = false;
        if (!companyId) return;
        this.pettyCash.shipmentCashRequests(companyId, shipmentId).subscribe({
            next: requests => {
                if (requestToken !== this.shipmentLoadRequestToken) return;
                this.shipmentCashRequests = requests;
                this.cdr.markForCheck();
            },
            error: () => {
                if (requestToken !== this.shipmentLoadRequestToken) return;
                this.shipmentCashError = true;
                this.cdr.markForCheck();
            }
        });
    }

    getOrderQuery(silent = false) {
        const requestedShipmentId = Number(this.shipmentId);
        const requestToken = ++this.shipmentLoadRequestToken;
        if (!silent) this.isLoading = true;
        this.shipmentService.getShipmentById(requestedShipmentId, 'en-US').subscribe({
            next: loadedShipment => {
                if (requestToken !== this.shipmentLoadRequestToken || Number(this.shipmentId) !== requestedShipmentId) {
                    return;
                }
                try {
                    this.shipment = loadedShipment ?? new Shipment();
                    this.consolidation = undefined;
                    this.consolidationLoading = false;
                    this.consolidationError = false;
                    this.releasePartyLabels = {};
                    if (this.isZeroSellConsolidation()) this.loadConsolidation(requestedShipmentId, requestToken);
                    this.shipment.deliveries = this.shipment.deliveries ?? [];
                    this.shipment.filesList = this.shipment.filesList ?? [];
                    this.shipment.remark = this.shipment.remark ?? {};
                    this.shipmentRemark = this.shipment.remark;
                    this.shipmentRemarksHtml = this.shipmentRemark.remarksHtml ?? '';
                    this.shipmentRemarksFeed = { entries: [] };
                    this.shipmentWaybillSummary = { deliveries: [] };
                    this.shipment.chargeLines = this.shipment.chargeLines ?? [];
                    this.shipment.payloadItemList = this.shipment.payloadItemList ?? [];
                    this.shipment.vehicleParaPack = this.shipment.vehicleParaPack ?? new Shipment().vehicleParaPack;
                    this.shipment.nominationPack = this.shipment.nominationPack ?? { sender: null, receiver: null, watchers: [] } as any;
                    this.shipment.nominationPack.watchers = this.shipment.nominationPack.watchers ?? [];

                    const shipmentAttachments = this.prepareShipmentAttachments(this.shipment.filesList ?? []);
                    this.shipment.filesList = shipmentAttachments;
                    this.shipment.deliveries.forEach((delivery: ShipmentDelivery) => {
                        delivery.filesList = shipmentAttachments.filter((attachment: ShipmentDeliveryAttachment) => Number(attachment.deliveryId) === Number(delivery.deliveryId));
                    });

                    this.waypointList = (this.shipment.waypoints ?? []).sort((a: ShipmentWaypoint, b: ShipmentWaypoint) => (a.waypointNumber || 0) - (b.waypointNumber || 0));
                    this.waypointRouteSegments = [];
                    this.refreshRouteOverviewPolyline();
                    this.resetManualWaypointOrder();
                    this.orderDeliveryList = this.shipment.deliveries
                        .filter((delivery: ShipmentDelivery) => delivery.deliveryType === ShipmentDeliveryType.DELIVERY)
                        .filter((delivery: ShipmentDelivery) => !this.isCancelledDelivery(delivery));
                    this.orderDeliveryMap = new Map(this.orderDeliveryList.map((delivery: ShipmentDelivery) => [delivery.deliveryId, delivery]));
                    this.deliveryOperationStatusById = {};
                    this.orderJobList = this.shipment.deliveries
                        .filter((delivery: ShipmentDelivery) => delivery.deliveryType === ShipmentDeliveryType.JOB)
                        .filter((delivery: ShipmentDelivery) => !this.isCancelledDelivery(delivery));
                    this.shipmentJobMap = new Map(this.orderJobList.map((job: ShipmentDelivery) => [job.deliveryId, job]));
                    this.tripsCount = this.orderDeliveryMap.size;
                    this.jobsCount = this.shipmentJobMap.size;
                    this.orderFilesList = this.sortShipmentAttachments(this.shipment.filesList);
                    this.orderFilesCount = this.orderFilesList.length;

                    this.pickupLocality = geoAddressHelpers.getLocality(this.shipment?.pickupAddress);
                    this.pickupSubLocality = geoAddressHelpers.getSubLocality(this.shipment?.pickupAddress);
                    this.dropoffLocality = geoAddressHelpers.getLocality(this.shipment?.dropoffAddress);
                    this.dropoffSubLocality = geoAddressHelpers.getSubLocality(this.shipment?.dropoffAddress);

                    this.breadcrumbItems = [{ label: 'Shipments', routerLink: '/shipment/company' }, { label: this.shipment.shipmentNumber }];
                    this.homeBreadcrumb = { icon: 'pi pi-home', routerLink: '/dashboard' };

                    this.generateAllNominees();
                    if (this.shipment.deliveries.length > 0) {
                        this.getLiveJobWithStatus();
                    } else {
                        this.orderQueryStatus = new ShipmentStatus();
                    }
                    //this.getAiSummary();
                    this.loadDispatchOperationStatuses(requestToken);
                    this.loadDeliveryRoutes(requestToken);
                    this.loadShipmentSecondaryData(requestedShipmentId, requestToken);
                    this.loadShipmentCashRequests(requestedShipmentId, requestToken);

                    //this.shipment.chargeLines.push(...this.orderDeliveryList.flatMap(value => value.chargeLines));
                } finally {
                    this.isLoading = false;
                    this.cdr.markForCheck();
                }
            },
            error: (error) => {
                if (requestToken !== this.shipmentLoadRequestToken || Number(this.shipmentId) !== requestedShipmentId) {
                    return;
                }
                console.error('Failed to load shipment view', error);
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load shipment details.'
                });
                this.isLoading = false;
                this.cdr.markForCheck();
            }
        });

    }

    private loadShipmentSecondaryData(shipmentId: number, requestToken: number): void {
        this.loadShipmentRouteSegments(shipmentId, requestToken);
        this.loadShipmentNotes(shipmentId, requestToken);
        this.loadShipmentWaybills(shipmentId, requestToken);
        if (this.shipment?.warehouseFlowDirection === 'INBOUND') {
            this.warehousingService.getShipmentInbounds(shipmentId).subscribe({
                next: response => {
                    if (requestToken !== this.shipmentLoadRequestToken) return;
                    this.shipmentInboundRequests = response.data || [];
                    this.cdr.markForCheck();
                },
                error: () => { this.shipmentInboundRequests = []; this.cdr.markForCheck(); }
            });
        } else this.shipmentInboundRequests = [];
        this.warehousingService.getReturnRequests(shipmentId).subscribe({
            next: response => {
                if (requestToken !== this.shipmentLoadRequestToken) return;
                this.returnWarehouseBlockers = (response.data || []).filter(row => row.status === 'BLOCKED');
                this.cdr.markForCheck();
            },
            error: () => { this.returnWarehouseBlockers = []; this.cdr.markForCheck(); }
        });
    }

    isZeroSellConsolidation(): boolean {
        return this.shipment?.billingMode === 'CONSOLIDATED_ZERO_SELL';
    }

    retryConsolidation(): void {
        if (this.isZeroSellConsolidation()) this.loadConsolidation(Number(this.shipmentId), this.shipmentLoadRequestToken);
    }

    private loadConsolidation(shipmentId: number, requestToken: number): void {
        this.consolidation = undefined;
        this.releasePartyLabels = {};
        this.consolidationLoading = true;
        this.consolidationError = false;
        this.shipmentService.getShipmentConsolidation(shipmentId).subscribe({
            next: result => {
                if (requestToken !== this.shipmentLoadRequestToken) return;
                this.consolidation = result;
                this.releasePartyLabels = {};
                for (const client of result.clients) for (const party of client.parties)
                    for (const release of party.releases)
                        this.releasePartyLabels[release.releaseId] = party.accountId || party.customerId
                            ? `${client.name} · ${party.name}` : client.name;
                this.consolidationLoading = false;
                this.cdr.markForCheck();
            },
            error: () => {
                if (requestToken !== this.shipmentLoadRequestToken) return;
                this.consolidationError = true;
                this.consolidationLoading = false;
                this.cdr.markForCheck();
            }
        });
    }

    retryShipmentRouteSegments(): void {
        this.loadShipmentRouteSegments(Number(this.shipmentId), this.shipmentLoadRequestToken);
    }

    private loadShipmentRouteSegments(shipmentId: number, requestToken: number): void {
        this.shipmentRouteSegmentsLoading = true;
        this.shipmentRouteSegmentsError = false;
        this.shipmentService.getWaypointRouteSegments(shipmentId).subscribe({
            next: segments => {
                if (requestToken !== this.shipmentLoadRequestToken) return;
                this.waypointRouteSegments = segments ?? [];
                this.shipmentRouteSegmentsLoading = false;
                this.refreshRouteOverviewPolyline();
                this.cdr.markForCheck();
            },
            error: () => {
                if (requestToken !== this.shipmentLoadRequestToken) return;
                this.shipmentRouteSegmentsLoading = false;
                this.shipmentRouteSegmentsError = true;
                this.cdr.markForCheck();
            }
        });
    }

    retryShipmentNotes(): void {
        this.loadShipmentNotes(Number(this.shipmentId), this.shipmentLoadRequestToken);
    }

    private loadShipmentNotes(shipmentId: number, requestToken: number): void {
        this.shipmentNotesLoading = true;
        this.shipmentNotesError = false;
        forkJoin({
            remark: this.shipmentService.getShipmentRemark(shipmentId),
            feed: this.shipmentService.getShipmentRemarksFeed(shipmentId)
        }).subscribe({
            next: ({ remark, feed }) => {
                if (requestToken !== this.shipmentLoadRequestToken) return;
                this.shipmentRemark = remark ?? {};
                this.shipment.remark = this.shipmentRemark;
                this.shipmentRemarksHtml = this.shipmentRemark.remarksHtml ?? '';
                this.shipmentRemarksFeed = feed ?? { entries: [] };
                this.shipmentNotesLoading = false;
                this.cdr.markForCheck();
            },
            error: () => {
                if (requestToken !== this.shipmentLoadRequestToken) return;
                this.shipmentNotesLoading = false;
                this.shipmentNotesError = true;
                this.cdr.markForCheck();
            }
        });
    }

    retryShipmentWaybills(): void {
        this.loadShipmentWaybills(Number(this.shipmentId), this.shipmentLoadRequestToken);
    }

    private loadShipmentWaybills(shipmentId: number, requestToken: number): void {
        this.shipmentWaybillsLoading = true;
        this.shipmentWaybillsError = false;
        this.shipmentService.getShipmentWaybills(shipmentId).subscribe({
            next: waybills => {
                if (requestToken !== this.shipmentLoadRequestToken) return;
                this.shipmentWaybillSummary = waybills ?? { deliveries: [] };
                this.shipmentWaybillsLoading = false;
                this.cdr.markForCheck();
            },
            error: () => {
                if (requestToken !== this.shipmentLoadRequestToken) return;
                this.shipmentWaybillsLoading = false;
                this.shipmentWaybillsError = true;
                this.cdr.markForCheck();
            }
        });
    }

    private prepareShipmentAttachments(attachments: ShipmentDeliveryAttachment[]): ShipmentDeliveryAttachment[] {
        return this.sortShipmentAttachments((attachments ?? []).map(attachment => this.normalizeShipmentAttachment(attachment)));
    }

    private normalizeShipmentAttachment(file: ShipmentDeliveryAttachment): ShipmentDeliveryAttachment {
        const deliveryId = Number(file?.deliveryId);
        const delivery = Number.isFinite(deliveryId) && deliveryId > 0
            ? this.orderDeliveryMap.get(deliveryId)
                ?? this.shipmentJobMap.get(deliveryId)
                ?? (this.shipment?.deliveries ?? []).find(item => Number(item.deliveryId) === deliveryId)
            : undefined;
        return {
            ...file,
            deliveryNumber: file.deliveryNumber ?? delivery?.deliveryNumber
        };
    }

    private sortShipmentAttachments(files: ShipmentDeliveryAttachment[]): ShipmentDeliveryAttachment[] {
        return [...(files ?? [])].sort((left, right) => Number(right.creationDate ?? 0) - Number(left.creationDate ?? 0));
    }

    private loadDispatchOperationStatuses(requestToken = this.shipmentLoadRequestToken): void {
        const shipmentId = this.shipment?.shipmentId;
        const deliveries = this.orderDeliveryList.filter(delivery => delivery.deliveryId);
        if (!shipmentId || deliveries.length === 0) {
            this.deliveryOperationStatusById = {};
            return;
        }

        forkJoin(deliveries.map(delivery =>
            this.shipmentService.getDeliveryOperationStatus(shipmentId, delivery.deliveryId)
                .pipe(catchError(() => of(undefined)))
        )).subscribe(statuses => {
            if (requestToken !== this.shipmentLoadRequestToken) {
                return;
            }
            const statusById: Record<number, ShipmentDeliveryOperationStatus> = {};
            statuses
                .filter((status): status is ShipmentDeliveryOperationStatus => Boolean(status?.deliveryId))
                .forEach(status => statusById[status.deliveryId!] = status);

            this.deliveryOperationStatusById = statusById;
            for (const delivery of this.orderDeliveryList) {
                const status = this.operationStatusFor(delivery);
                if (status?.deliveryStatus) {
                    delivery.workflowState = status.deliveryStatus;
                }
            }
            this.cdr.markForCheck();
        });
    }

    private loadDeliveryRoutes(requestToken = this.shipmentLoadRequestToken): void {
        const deliveries = this.orderDeliveryList.filter(delivery => delivery.deliveryId);
        if (!this.shipmentId || !deliveries.length) { this.deliveryRoutes = []; return; }
        forkJoin(deliveries.map(delivery => this.shipmentService.getDeliveryStops(this.shipmentId, delivery.deliveryId)
            .pipe(catchError(() => of([] as ShipmentDeliveryStop[]))))).subscribe(routes => {
            if (requestToken !== this.shipmentLoadRequestToken) return;
            this.deliveryRoutes = deliveries.map((delivery, index) => ({
                deliveryNumber: delivery.deliveryNumber,
                stops: routes[index].sort((first, second) => (first.stopNumber ?? 0) - (second.stopNumber ?? 0))
            })).filter(route => route.stops.length > 0);
            this.cdr.markForCheck();
        });
    }

    getAiSummary() {
        this.aiSummaryService.getShipmentSummary(this.shipment)
            .subscribe((value: string) => {
                // Remove code block markers and split into sentences
                const sentences = value.replace('```html', '')
                    .replace('```', '')
                    .replace('\n', '<br>')
                    .split('. ');

                // Process each sentence to wrap bold text in <strong> tags
                const formattedSummary = sentences.map((sentence: string) => {
                    return sentence.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') + '. ';
                }).join('');

                // Sanitize the formatted HTML
                this.shipmentAiSummary = this.sanitizer.sanitize(SecurityContext.HTML, formattedSummary);
            }, (error: any) => {
                this.shipmentAiSummary = 'Error in generating AI Summary, please try again later';
            });
    }

    showDate(longDate: number | undefined) {
        return longDate ? formatDate(new Date(longDate), 'dd-MM-yyyy HH:mm', 'en-US') : '';
    }

    scheduleDateLabel(value: Date | number | string | null | undefined): string {
        if (value == null || value === '') return '';
        const date = value instanceof Date ? value : new Date(value);
        return Number.isNaN(date.getTime()) ? '' : formatDate(date, 'dd-MM-yyyy HH:mm', 'en-US');
    }

    private isPrimaryPickupWaypoint(waypoint: ShipmentWaypoint): boolean {
        return waypoint?.waypointType === 'PICKUP' && this.sameWaypoint(this.waypointList?.[0], waypoint);
    }

    private isFinalDropoffWaypoint(waypoint: ShipmentWaypoint): boolean {
        const finalWaypoint = this.waypointList?.[this.waypointList.length - 1];
        return this.isDropoffWaypoint(waypoint) && this.sameWaypoint(finalWaypoint, waypoint);
    }

    private isDropoffWaypoint(waypoint?: ShipmentWaypoint): boolean {
        const waypointType = String(waypoint?.waypointType || '').toUpperCase();
        return waypointType === 'DROPOFF' || waypointType === 'CROSS_DOCK';
    }

    private isCrossDockWaypoint(waypoint?: ShipmentWaypoint): boolean {
        return this.isDropoffWaypoint(waypoint) && this.isWarehouseLocation(waypoint);
    }

    private isWarehouseLocation(waypoint?: ShipmentWaypoint): boolean {
        const location = waypoint?.location;
        const locationType = String(location?.locationType || '').toUpperCase();
        return location?.isWarehouse === true || locationType === 'WAREHOUSE';
    }

    private secondaryWaypointIndex(waypoint: ShipmentWaypoint, type: string): number {
        return (this.waypointList ?? [])
            .filter(routeWaypoint => {
                const matchesType = type === 'DROPOFF'
                    ? this.isDropoffWaypoint(routeWaypoint) && !this.isCrossDockWaypoint(routeWaypoint)
                    : routeWaypoint.waypointType === type;
                return matchesType && !this.isPrimaryPickupWaypoint(routeWaypoint) && !this.isFinalDropoffWaypoint(routeWaypoint);
            })
            .findIndex(routeWaypoint => this.sameWaypoint(routeWaypoint, waypoint)) + 1;
    }

    private sameWaypoint(left?: ShipmentWaypoint, right?: ShipmentWaypoint): boolean {
        if (!left || !right) return false;
        if (left.waypointId != null && right.waypointId != null) {
            return left.waypointId === right.waypointId;
        }
        return left === right || left.waypointNumber === right.waypointNumber;
    }

    private formatWaypointDate(value?: string): string {
        if (!value) return '';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return '';
        return formatDate(date, 'dd-MM-yyyy HH:mm', 'en-US');
    }

    viewDeliveryPage(orderDelivery: ShipmentDelivery): void {
        this.router.navigate(
            [`shipment/delivery/view`, orderDelivery.deliveryId]
        );
    }

    waypointGoogleMapsUrl(waypoint: ShipmentWaypoint): string | null {
        const latitude = waypoint?.location?.location?.latitude;
        const longitude = waypoint?.location?.location?.longitude;
        if (typeof latitude !== 'number' || typeof longitude !== 'number'
            || !Number.isFinite(latitude) || !Number.isFinite(longitude)
            || latitude < -90 || latitude > 90 || longitude < -180 || longitude > 180) {
            return null;
        }
        return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${latitude},${longitude}`)}`;
    }

    async shareWaypointLocation(waypoint: ShipmentWaypoint): Promise<void> {
        const url = this.waypointGoogleMapsUrl(waypoint);
        if (!url) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Location unavailable',
                detail: 'This waypoint needs valid latitude and longitude before it can be shared.'
            });
            return;
        }

        const locationName = waypoint.location?.name || 'Shipment location';
        const shareData = {
            title: locationName,
            text: `Google Maps location for ${locationName}`,
            url
        };
        if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
            try {
                await navigator.share(shareData);
            } catch (error: unknown) {
                if ((error as DOMException)?.name !== 'AbortError') {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Location share failed',
                        detail: 'The Google Maps link could not be shared. Try again or open it in Maps.'
                    });
                }
            }
            return;
        }

        if (typeof navigator === 'undefined' || !navigator.clipboard?.writeText) {
            this.messageService.add({
                severity: 'info',
                summary: 'Copy the location link',
                detail: 'Open the location in Maps and copy the Google Maps URL from the address bar.'
            });
            return;
        }

        try {
            await navigator.clipboard.writeText(url);
            this.messageService.add({
                severity: 'success',
                summary: 'Location link copied',
                detail: 'Paste the Google Maps URL in WhatsApp, email, or another app.'
            });
        } catch {
            this.messageService.add({
                severity: 'error',
                summary: 'Could not copy location link',
                detail: 'Open the location in Maps and copy the Google Maps URL from the address bar.'
            });
        }
    }

    getStaticMapUrl(): string {
        if (!this.googleMapsApiKey) return '';
        const waypoints = (this.waypointList ?? []).filter(waypoint => this.waypointGoogleMapsUrl(waypoint));
        if (waypoints.length === 0) return '';

        const markers = waypoints.map((waypoint, index) =>
            `markers=color:blue|label:${index + 1}|${waypoint.location.location.latitude},${waypoint.location.location.longitude}`
        ).join('&');

        const path = this.routeOverviewPolyline
            ? `path=color:0x4f46e5|weight:5|enc:${encodeURIComponent(this.routeOverviewPolyline)}`
            : waypoints.length > 1
                ? 'path=color:0x4f46e5|weight:5|' + waypoints.map(w => `${w.location.location.latitude},${w.location.location.longitude}`).join('|')
                : '';

        return `https://maps.googleapis.com/maps/api/staticmap?size=640x480&scale=2&maptype=roadmap&${markers}${path ? '&' + path : ''}&key=${this.googleMapsApiKey}`;
    }

    private refreshRouteOverviewPolyline(): void {
        this.routeOverviewPolyline = undefined;
        const routeWaypoints = (this.waypointList ?? []).filter(waypoint => this.waypointGoogleMapsUrl(waypoint));
        if (routeWaypoints.length < 2 || typeof google === 'undefined' || !google.maps?.TravelMode) {
            return;
        }

        const origin = this.toLatLngLiteral(routeWaypoints[0]);
        const destination = this.toLatLngLiteral(routeWaypoints[routeWaypoints.length - 1]);
        const intermediateWaypoints = routeWaypoints.slice(1, -1).map(waypoint => ({
            location: this.toLatLngLiteral(waypoint),
            stopover: true
        }));

        const request: google.maps.DirectionsRequest = {
            origin,
            destination,
            waypoints: intermediateWaypoints,
            travelMode: google.maps.TravelMode.DRIVING,
            unitSystem: google.maps.UnitSystem.METRIC
        };

        this.mapDirectionsService.route(request).pipe(
            catchError(() => of(null))
        ).subscribe(response => {
            const route = response?.result?.routes?.[0] as any;
            this.routeOverviewPolyline = route?.overview_polyline || undefined;
            this.cdr.markForCheck();
        });
    }

    private toLatLngLiteral(waypoint: ShipmentWaypoint): google.maps.LatLngLiteral {
        return {
            lat: waypoint.location.location.latitude,
            lng: waypoint.location.location.longitude
        };
    }

    openAddWaypointDialog(insertAfterWaypoint?: ShipmentWaypoint) {
        this.waypointDialogMode = 'create';
        this.waypointDialogPurpose = 'standard';
        this.selectedWaypointForLocationEdit = undefined;
        this.insertAfterSequence = insertAfterWaypoint ? insertAfterWaypoint.waypointNumber : 0;
        this.newWaypoint = new ShipmentWaypoint();
        this.newWaypoint.waypointNumber = this.insertAfterSequence + 1;
        this.addWaypointDialogVisible = true;
    }

    openEditWaypointLocationDialog(waypoint: ShipmentWaypoint): void {
        if (!waypoint?.waypointId) return;

        this.waypointDialogMode = 'edit-location';
        this.waypointDialogPurpose = 'standard';
        this.selectedWaypointForLocationEdit = waypoint;
        this.newWaypoint = {
            ...waypoint,
            lineItems: waypoint.lineItems ? [...waypoint.lineItems] : []
        } as ShipmentWaypoint;
        this.addWaypointDialogVisible = true;
    }

    hideAddWaypointDialog() {
        this.addWaypointDialogVisible = false;
        this.waypointDialogMode = 'create';
        this.waypointDialogPurpose = 'standard';
        this.selectedWaypointForLocationEdit = undefined;
    }

    saveNewWaypoint(waypoint: ShipmentWaypoint) {
        if (this.waypointDialogMode === 'edit-location') {
            this.saveWaypointLocation(waypoint);
            return;
        }

        this.addWaypointInProgress = true;
        if (this.waypointDialogPurpose === 'return') {
            waypoint = {
                ...waypoint,
                waypointNumber: (this.waypointList?.length ?? 0) + 1,
                waypointType: ShipmentWaypointType.DROPOFF,
                remarks: this.buildReturnWaypointRemark(waypoint.remarks)
            } as ShipmentWaypoint;
        }
        this.shipmentService.createWaypoint(this.shipmentId, waypoint).subscribe({
            next: (savedWaypoint: ShipmentWaypoint) => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Waypoint added successfully.' });
                this.hideAddWaypointDialog();
                this.resetManualWaypointOrder();
                this.getOrderQuery(); // Refresh all shipment data
            },
            error: (err: any) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to save waypoint.' });
                this.cdr.markForCheck();
            }
        }).add(() => {
            this.addWaypointInProgress = false;
            this.cdr.markForCheck();
        });
    }

    private saveWaypointLocation(waypoint: ShipmentWaypoint): void {
        if (!this.selectedWaypointForLocationEdit?.waypointId || !waypoint?.location) return;

        this.addWaypointInProgress = true;
        const updatedWaypoint = {
            ...this.selectedWaypointForLocationEdit,
            location: waypoint.location
        } as ShipmentWaypoint;

        this.shipmentService.updateWaypoint(this.shipmentId, this.selectedWaypointForLocationEdit.waypointId, updatedWaypoint).subscribe({
            next: () => {
                this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Waypoint location updated.' });
                this.hideAddWaypointDialog();
                this.resetManualWaypointOrder();
                this.getOrderQuery();
            },
            error: (err: any) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.message || 'Failed to update waypoint location.' });
                this.cdr.markForCheck();
            }
        }).add(() => {
            this.addWaypointInProgress = false;
            this.cdr.markForCheck();
        });
    }

    startManualWaypointOrder(): void {
        this.manualWaypointOrderMode = true;
        this.waypointOrderDirty = false;
        this.waypointOrderSnapshot = this.cloneWaypointOrder(this.waypointList);
    }

    cancelManualWaypointOrder(): void {
        this.waypointList = this.cloneWaypointOrder(this.waypointOrderSnapshot);
        this.resetManualWaypointOrder();
        this.refreshRouteOverviewPolyline();
        this.cdr.markForCheck();
    }

    moveWaypoint(index: number, direction: -1 | 1): void {
        const targetIndex = index + direction;
        if (targetIndex < 0 || targetIndex >= this.waypointList.length || this.waypointOrderSaveInProgress) return;

        const reordered = [...this.waypointList];
        [reordered[index], reordered[targetIndex]] = [reordered[targetIndex], reordered[index]];
        this.waypointList = this.resequenceWaypoints(reordered);
        this.routeOverviewPolyline = undefined;
        this.waypointOrderDirty = true;
        this.cdr.markForCheck();
    }

    saveWaypointOrder(): void {
        if (!this.shipmentId || !this.waypointOrderDirty || this.waypointOrderSaveInProgress) return;

        this.waypointOrderSaveInProgress = true;
        const orderedWaypoints = this.resequenceWaypoints(this.waypointList);
        if (!this.hasValidPickupDropoffOrder(orderedWaypoints)) {
            this.waypointOrderSaveInProgress = false;
            this.messageService.add({ severity: 'warn', summary: 'Invalid order', detail: 'Keep at least one pickup before a dropoff.' });
            this.cdr.markForCheck();
            return;
        }

        this.shipmentService.replaceWaypoints(this.shipmentId, orderedWaypoints).subscribe({
            next: (waypoints: ShipmentWaypoint[]) => {
                this.waypointList = this.resequenceWaypoints(waypoints);
                this.resetManualWaypointOrder();
                this.refreshRouteOverviewPolyline();
                this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Waypoint order updated.' });
                this.cdr.markForCheck();
            },
            error: error => {
                this.waypointList = this.cloneWaypointOrder(this.waypointOrderSnapshot);
                this.resetManualWaypointOrder();
                this.refreshRouteOverviewPolyline();
                this.messageService.add({ severity: 'error', summary: 'Waypoint order unchanged',
                    detail: error?.error?.message || error?.error?.detail || 'Failed to update waypoint order.' });
                this.cdr.markForCheck();
            }
        }).add(() => {
            this.waypointOrderSaveInProgress = false;
            this.cdr.markForCheck();
        });
    }

    private resetManualWaypointOrder(): void {
        this.manualWaypointOrderMode = false;
        this.waypointOrderDirty = false;
        this.waypointOrderSnapshot = [];
    }

    private cloneWaypointOrder(waypoints: ShipmentWaypoint[]): ShipmentWaypoint[] {
        return waypoints.map(waypoint => ({ ...waypoint }));
    }

    private buildReturnWaypoint(location?: Location): ShipmentWaypoint {
        const waypoint = new ShipmentWaypoint();
        waypoint.waypointNumber = (this.waypointList?.length ?? 0) + 1;
        waypoint.waypointType = ShipmentWaypointType.DROPOFF;
        waypoint.status = 'PENDING';
        waypoint.remarks = this.buildReturnWaypointRemark();
        waypoint.location = location as Location;
        waypoint.lineItems = [];
        return waypoint;
    }

    private buildReturnWaypointRemark(existing?: string): string {
        const suffix = existing?.trim();
        if (suffix && suffix.toUpperCase().includes(RETURN_WAYPOINT_REMARK)) {
            return suffix;
        }
        return suffix ? `${RETURN_WAYPOINT_REMARK}: ${suffix}` : RETURN_WAYPOINT_REMARK;
    }

    private resequenceWaypoints(waypoints: ShipmentWaypoint[]): ShipmentWaypoint[] {
        return waypoints.map((waypoint, index) => ({ ...waypoint, waypointNumber: index + 1 }));
    }

    private hasValidPickupDropoffOrder(waypoints: ShipmentWaypoint[]): boolean {
        const hasPickup = waypoints.some(waypoint => waypoint.waypointType === 'PICKUP');
        const hasDropoff = waypoints.some(waypoint => waypoint.waypointType === 'DROPOFF');
        if (!hasPickup || !hasDropoff) return true;

        let pickupSeen = false;
        for (const waypoint of waypoints) {
            if (waypoint.waypointType === 'PICKUP') {
                pickupSeen = true;
            } else if (waypoint.waypointType === 'DROPOFF' && pickupSeen) {
                return true;
            }
        }
        return false;
    }

    getLiveJobWithStatus(): void {
        // A refresh must replace, rather than duplicate, the previous listener.
        this.liveJobStatusSubscription?.unsubscribe();

        const jobStatusRef = ref(this.database, `shipment/${this.shipmentId}`);

        this.liveJobStatusSubscription = stateChanges(jobStatusRef, { events: [ListenEvent.added, ListenEvent.changed] })
            .pipe(concatMap(changeEvent => this.updateOrderStatus(changeEvent.snapshot, this.orderQueryStatus)
                .pipe(catchError(() => of(null)))))
            .subscribe({
                next: () => this.cdr.markForCheck(),
                error: () => {
                    // Some portal users may not be granted Realtime Database access.
                    // REST remains the authoritative source for this screen.
                    this.orderQueryStatus = new ShipmentStatus();
                    this.cdr.markForCheck();
                }
            });
    }


    updateOrderStatus(snapShot: DataSnapshot, shipmentStatus: ShipmentStatus): Observable<any> {
        if (snapShot.key?.includes('isJobsGenerated')) {
            // 4. Access data directly with snapShot.val()
            shipmentStatus.isJobsGenerated = snapShot.val() as boolean;
            return of(null);
        }

        if (snapShot.key?.includes('shipmentStatus')) {
            shipmentStatus.shipmentStatus = snapShot.val() as any;
            this.shipment.shipmentStatus = shipmentStatus.shipmentStatus as any;
            return of(null);
        }

        const deliveryId = Number(snapShot.key);
        if (!isNaN(deliveryId)) {
            const shipmentDeliveryJobStatus = snapShot.val() as ShipmentDeliveryJobStatus;
            shipmentStatus.shipmentDeliveryStatus.set(deliveryId, shipmentDeliveryJobStatus);

            if (Object.values(ShipmentJobStatus).indexOf(shipmentDeliveryJobStatus.jobStatus as ShipmentJobStatus) < Object.values(ShipmentJobStatus).indexOf(ShipmentJobStatus.JOB_DRIVER_ACCEPTED)) {
                if (!this.shipmentJobMap.has(deliveryId)) {
                    return this.shipmentService.getDeliveryById(this.shipmentId, deliveryId).pipe(
                        tap((shipmentJob: ShipmentDelivery) => {
                            shipmentJob.jobStatus = shipmentDeliveryJobStatus.jobStatus;
                            shipmentJob.jobStatusMap = shipmentDeliveryJobStatus.jobStatusMap;
                            this.messageService.add({ severity: "info", closable: true, summary: 'Status of Job# ' + deliveryId + ' is updated', detail: shipmentJob.jobStatus, life: 6000 });
                            this.shipmentJobMap.set(deliveryId, shipmentJob);
                            this.orderJobList = Array.from(this.shipmentJobMap.values());
                            this.jobsCount = this.shipmentJobMap.size;
                        })
                    );
                } else {
                    const shipmentJob = this.shipmentJobMap.get(deliveryId)!;
                    shipmentJob.jobStatus = shipmentDeliveryJobStatus.jobStatus;
                    shipmentJob.jobStatusMap = shipmentDeliveryJobStatus.jobStatusMap;
                    this.orderJobList = [...this.orderJobList];
                    this.messageService.add({ severity: "info", closable: true, summary: 'Status of Job# ' + deliveryId + ' is updated', detail: shipmentJob.jobStatus, life: 6000 });
                    return of(null);
                }
            }

            if (Object.values(ShipmentJobStatus).indexOf(shipmentDeliveryJobStatus.jobStatus as ShipmentJobStatus) >= Object.values(ShipmentJobStatus).indexOf(ShipmentJobStatus.JOB_DRIVER_ACCEPTED)) {
                this.shipmentJobMap.delete(deliveryId);
                this.orderJobList = Array.from(this.shipmentJobMap.values());
                this.jobsCount = this.shipmentJobMap.size;
                if (!this.orderDeliveryMap.has(deliveryId)) {
                    return this.shipmentService.getDeliveryById(this.shipmentId, deliveryId).pipe(
                        tap((shipmentDelivery: ShipmentDelivery) => {
                            shipmentDelivery.jobStatus = shipmentDeliveryJobStatus.jobStatus;
                            shipmentDelivery.jobStatusMap = shipmentDeliveryJobStatus.jobStatusMap;
                            shipmentDelivery.filesList = shipmentDelivery.filesList ?? [];
                            shipmentDelivery.chargeLines = shipmentDelivery.chargeLines ?? [];
                            this.messageService.add({ severity: shipmentDeliveryJobStatus.jobStatus === ShipmentJobStatus.JOB_DRIVER_ACCEPTED ? "success" : "info", closable: true, summary: 'Status of Delivery# ' + deliveryId + ' is updated', detail: shipmentDelivery.jobStatus, life: 6000 });
                            this.orderDeliveryMap.set(deliveryId, shipmentDelivery);
                            this.orderDeliveryList = Array.from(this.orderDeliveryMap.values());
                            this.tripsCount = this.orderDeliveryMap.size;
                        })
                    );
                } else {
                    const orderDelivery = this.orderDeliveryMap.get(deliveryId)!;
                    orderDelivery.jobStatus = shipmentDeliveryJobStatus.jobStatus;
                    orderDelivery.jobStatusMap = shipmentDeliveryJobStatus.jobStatusMap;
                    this.orderDeliveryList = [...this.orderDeliveryList];
                    this.messageService.add({ severity: shipmentDeliveryJobStatus.jobStatus === ShipmentJobStatus.JOB_DRIVER_ACCEPTED ? "success" : "info", closable: true, summary: 'Status of Delivery# ' + deliveryId + ' is updated', detail: orderDelivery.jobStatus, life: 6000 });
                }
            }
        }
        return of(null);
    }

    invokeDriver(orderJob: ShipmentDelivery) {
        if (this.invokeDriverInProgress || !this.isInvocablePendingJob(orderJob)) return;
        this.invokeDriverInProgress = true;
        this.shipmentService.changeDeliveryStatus(this.shipmentId, orderJob.deliveryId, ShipmentJobStatus.JOB_INVOKE_DRIVER)
            .pipe(finalize(() => {
                this.invokeDriverInProgress = false;
                this.cdr.markForCheck();
            })).subscribe({
            next: () => {
                this.applyInvokedStatus(orderJob);
                this.messageService.add({ severity: 'success', summary: 'Driver invoked', detail: `${orderJob.deliveryNumber} is ready for confirmation.` });
            },
            error: (error) => this.messageService.add({ severity: 'error', summary: 'Invocation failed', detail: error?.error?.message || 'Could not invoke this driver.' })
        });
    }

    findNewDrivers() {
        /*this.shipmentService.findVehiclesNow(this.shipment, 'en-US')
            .subscribe(createdOrderResponse => {
                console.log('Order Query Response: ' + JSON.stringify(createdOrderResponse));
                if (createdOrderResponse.success) {
                    this.messageService.add({
                        severity: 'success', summary: 'Request submitted!',
                        detail: 'Request for finding drivers has been submitted!'
                    });
                } else {
                    this.messageService.add({
                        severity: 'error', summary: 'Error in finding drivers',
                        detail: 'There was an error in finding drivers: ' + createdOrderResponse.message
                    });
                }
            });*/
    }

    addNewFile() {
        if (!this.shipment?.shipmentId) {
            this.messageService.add({ severity: 'error', summary: 'Upload blocked', detail: 'Reload the shipment and try again.' });
            return;
        }
        this.sessionStorageService.setShipmentUploadContext(this.shipment.shipmentId);

        // Define the callback function
        const fileUploadCallback: ShipmentFileDownloadUrlCallback = (file: ShipmentDeliveryAttachment, batchComplete?: boolean) => {
            const normalizedFile = this.normalizeShipmentAttachment(file);
            this.shipment.filesList = this.sortShipmentAttachments([...(this.shipment.filesList ?? []), normalizedFile]);
            this.orderFilesList = this.sortShipmentAttachments(this.shipment.filesList);
            this.orderFilesCount = this.orderFilesList.length;
            this.cdr.markForCheck();
            if (batchComplete) fileUploadDialog.close();
        };

        // Open the dialog with the callback
        let fileUploadDialog = this.dialogService.open(ShipmentFileUploadComponent, {
            header: 'Create/Upload Order File',
            width: 'min(48rem, calc(100vw - 1.5rem))',
            modal: true,
            data: { callback: fileUploadCallback },
        });
    }

    onShipmentPayloadDocumentSelected(event: Event | File): void {
        if (this.isCancelledShipment()) return;
        const input = event instanceof File ? undefined : event.target as HTMLInputElement;
        const file = event instanceof File ? event : input?.files?.[0];
        if (input) input.value = '';
        if (!file || !this.shipmentId) {
            return;
        }

        this.payloadExtractionInProgress = true;
        this.shipmentService.extractShipmentPayload(this.shipmentId, file).pipe(
            finalize(() => {
                this.payloadExtractionInProgress = false;
                this.cdr.markForCheck();
            })
        ).subscribe({
            next: result => {
                this.shipment.payloadItemList = result.payloadItemList ?? [];
                if (result.customerOrderNumber) {
                    this.shipment.customerOrderNumber = result.customerOrderNumber;
                }
                if (result.attachment) {
                    const normalizedFile = this.normalizeShipmentAttachment(result.attachment);
                    this.shipment.filesList = this.sortShipmentAttachments([...(this.shipment.filesList ?? []), normalizedFile]);
                    this.orderFilesList = this.sortShipmentAttachments(this.shipment.filesList);
                    this.orderFilesCount = this.orderFilesList.length;
                }
                this.messageService.add({
                    severity: 'success',
                    summary: 'Payload extracted',
                    detail: `${this.payloadCount()} payload line${this.payloadCount() === 1 ? '' : 's'} applied.`
                });
            },
            error: error => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Extraction failed',
                    detail: error?.error?.message || 'Could not extract payload from the document.'
                });
            }
        });
    }

    onShipmentPayloadChanged(result: ShipmentPayloadLineCommandResult): void {
        this.shipment.payloadItemList = result.payloadItems ?? [];
        this.cdr.markForCheck();
    }

    deleteAttachment(file: ShipmentDeliveryAttachment): void {
        if (!file.attachmentId) {
            return;
        }
        this.confirmationService.confirm({
            message: 'Delete this attachment?',
            header: 'Delete Attachment',
            icon: 'pi pi-trash',
            accept: () => {
                this.shipmentService.deleteAttachment(file.attachmentId!).subscribe({
                    next: () => {
                        this.orderFilesList = this.orderFilesList.filter(attachment => attachment.attachmentId !== file.attachmentId);
                        this.shipment.filesList = (this.shipment.filesList ?? []).filter(attachment => attachment.attachmentId !== file.attachmentId);
                        this.shipment.deliveries?.forEach(delivery => {
                            delivery.filesList = (delivery.filesList ?? []).filter(attachment => attachment.attachmentId !== file.attachmentId);
                        });
                        this.orderFilesCount = this.orderFilesList.length;
                        this.messageService.add({ severity: 'success', summary: 'Deleted', detail: 'Attachment removed.' });
                        this.cdr.markForCheck();
                    },
                    error: () => {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete attachment.' });
                        this.cdr.markForCheck();
                    }
                });
            }
        });
    }

    generateDeliveries() {
        if (!this.shipment?.shipmentId || this.isCancelledShipment()) return;
        this.router.navigate([`shipment/delivery`, this.shipment.shipmentId, 'generate']);
    }

    activeTabIndex = 0;
    onTabChange(event: { index: number | string }): void {
        this.activeTabIndex = event.index as number;
        this.updateShipmentTabQueryParam();
    }

    private resolveShipmentTabIndex(tabKey: string | null): number {
        if (!tabKey) {
            return 0;
        }

        const normalizedTabKey = tabKey.toLowerCase();
        if (normalizedTabKey === 'financials' && !this.canViewShipmentPricing()) {
            return 0;
        }

        const tabIndex = this.shipmentTabKeys.findIndex(key => key === normalizedTabKey);
        if (tabIndex === -1) {
            return 0;
        }
        if (this.shipmentTabKeys[tabIndex] === 'financials' && !this.canViewShipmentPricing()) {
            return 0;
        }
        return tabIndex;
    }

    private updateShipmentTabQueryParam(): void {
        const tabKey = this.shipmentTabKeys[this.activeTabIndex];
        if (!tabKey) {
            return;
        }
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { tab: tabKey },
            queryParamsHandling: 'merge',
            replaceUrl: true
        });
    }

    saveShipmentRemarks(): void {
        if (!this.shipment?.shipmentId) {
            return;
        }
        this.saveShipmentRemarksInProgress = true;
        this.shipmentService.saveShipmentRemark(this.shipment.shipmentId, {
            ...this.shipmentRemark,
            shipmentId: this.shipment.shipmentId,
            deliveryId: null,
            remarksHtml: this.shipmentRemarksHtml,
            updatedByCustomerId: this.sessionStorageService.getCustomer()?.id
        }).subscribe({
            next: remark => {
                this.shipmentRemark = remark;
                this.shipment.remark = remark;
                this.shipmentRemarksHtml = remark.remarksHtml ?? '';
                this.shipmentService.getShipmentRemarksFeed(this.shipment.shipmentId!).subscribe({
                    next: feed => this.shipmentRemarksFeed = feed ?? { entries: [] }
                });
                this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Shipment notes updated.' });
                this.saveShipmentRemarksInProgress = false;
                this.cdr.markForCheck();
            },
            error: () => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to save shipment notes.' });
                this.saveShipmentRemarksInProgress = false;
                this.cdr.markForCheck();
            }
        });
    }

    optimizeWaypoints() {
        if (!this.shipment.shipmentId) return;

        const previousOrder = (this.waypointList ?? []).map(waypoint => waypoint.waypointId).join(',');
        this.isLoading = true;
        this.shipmentService.optimizeWaypoints(this.shipment.shipmentId).subscribe({
            next: (waypoints: ShipmentWaypoint[]) => {
                const optimizedWaypoints = this.resequenceWaypoints(waypoints ?? []);
                const optimizedOrder = optimizedWaypoints.map(waypoint => waypoint.waypointId).join(',');
                if (optimizedWaypoints.length > 0) {
                    this.waypointList = optimizedWaypoints;
                    this.waypointRouteSegments = [];
                }
                const routeChanged = optimizedOrder && optimizedOrder !== previousOrder;
                this.messageService.add({
                    severity: routeChanged ? 'success' : 'info',
                    summary: routeChanged ? 'Route optimized' : 'No route change',
                    detail: routeChanged
                        ? 'Waypoint order updated using the shortest route where ETA is effectively tied.'
                        : 'Current waypoint order is already optimal for the selected routing rules.'
                });
                this.getOrderQuery();
            },
            error: (err: any) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to optimize route' });
            }
        }).add(() => {
            this.isLoading = false;
            this.cdr.markForCheck();
        });
    }

    openDeliveryCancellationDialog(delivery: ShipmentDelivery): void {
        if (!delivery?.deliveryId || !this.permissionService.hasPermission(app_permissions.shipments.deliveries.edit)) {
            return;
        }
        this.deliveryToCancel = delivery;
        this.deliveryCancellationReason = '';
        this.deliveryCancellationDialogVisible = true;
    }

    closeDeliveryCancellationDialog(): void {
        if (this.deliveryCancellationInProgress) return;
        this.deliveryCancellationDialogVisible = false;
        this.deliveryToCancel = undefined;
        this.deliveryCancellationReason = '';
    }

    cancelPendingDelivery(): void {
        const deliveryId = this.deliveryToCancel?.deliveryId;
        if (!this.shipment?.shipmentId || !deliveryId) return;
        const reason = this.deliveryCancellationReason.trim();
        if (!reason) {
            this.messageService.add({ severity: 'warn', summary: 'Reason required', detail: 'Enter the reason for cancelling this delivery.' });
            return;
        }
        this.deliveryCancellationInProgress = true;
        this.shipmentService.cancelDelivery(this.shipment.shipmentId, deliveryId, {
            reason,
            actorCustomerId: this.sessionStorageService.getCustomer()?.id
        }).subscribe({
            next: () => {
                this.messageService.add({ severity: 'success', summary: 'Delivery cancelled', detail: 'The cancelled delivery no longer counts toward shipment fulfilment.' });
                this.deliveryCancellationInProgress = false;
                this.closeDeliveryCancellationDialog();
                this.getOrderQuery();
            },
            error: (error: any) => {
                this.deliveryCancellationInProgress = false;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Cancellation blocked',
                    detail: error?.error?.message || 'The delivery could not be cancelled.'
                });
                this.cdr.markForCheck();
            }
        });
    }

    onDispatchDialogCommand(command: ShipmentDispatchDialogCommand): void {
        switch (command.type) {
            case 'close-watcher':
                this.hideAddWatcherDialog();
                return;
            case 'select-watcher':
                this.selectedWatcher = command.contact;
                return;
            case 'save-watcher':
                this.saveWatcher();
                return;
            case 'close-amendment':
                this.closeReleaseAmendment();
                return;
            case 'set-amendment-step':
                this.releaseAmendmentStep = command.step;
                this.cdr.markForCheck();
                return;
            case 'toggle-release':
                this.toggleRelease(command.releaseId);
                return;
            case 'set-release-search':
                this.releaseSearch = command.value;
                return;
            case 'search-releases':
                this.loadReleaseCandidates(0);
                return;
            case 'page-releases':
                this.loadReleaseCandidates(command.page);
                return;
            case 'attach-releases-to-shipment':
                this.attachOrderReleasesToShipment();
                return;
            case 'apply-shipment-attachment':
                this.applyOrderReleaseAttachment();
                return;
            case 'preview-amendment':
                this.previewReleaseAmendment();
                return;
            case 'confirm-amendment-prices':
                this.moveReleaseAmendmentToConfirmation();
                return;
            case 'set-amendment-buying-price':
                this.releaseAmendmentBuyingPrice = command.value;
                return;
            case 'set-amendment-selling-price':
                this.releaseAmendmentSellingPrice = command.value;
                return;
            case 'set-amendment-reason':
                this.releaseAmendmentReason = command.value;
                return;
            case 'apply-amendment':
                this.applyReleaseAmendment();
                return;
            case 'retry-bayan':
                this.retryReleaseAmendmentBayan(command.amendment);
                return;
            case 'close-cancellation':
                this.closeDeliveryCancellationDialog();
                return;
            case 'set-cancellation-reason':
                this.deliveryCancellationReason = command.value;
                return;
            case 'confirm-cancellation':
                this.cancelPendingDelivery();
                return;
        }
    }

    onDispatchCommand(command: ShipmentDispatchCommand): void {
        if (this.isCancelledShipment() && command.type !== 'track') {
            return;
        }
        switch (command.type) {
            case 'assign-driver-vehicle':
                this.generateDeliveries();
                return;
            case 'invoke-all':
                this.invokeDrivers(this.orderJobList);
                return;
            case 'confirm-all':
                this.confirmDrivers(this.orderJobList);
                return;
            case 'invoke':
                this.invokeDriver(command.delivery);
                return;
            case 'confirm':
                this.confirmDriver(command.delivery);
                return;
            case 'cancel':
                this.openDeliveryCancellationDialog(command.delivery);
                return;
            case 'track':
                this.viewDeliveryPage(command.delivery);
                return;
            case 'amend':
                this.openReleaseAmendment(command.delivery);
                return;
        }
    }

    onFinancialsCommand(command: ShipmentFinancialsCommand): void {
        if (this.isCancelledShipment()) return;
        if (command.type === 'add-charge') {
            this.addNewChargeLine();
            return;
        }
        this.editChargeLine(command.chargeLine);
    }

    onFilesCommand(command: ShipmentFilesCommand): void {
        if (this.isCancelledShipment()) return;
        if (command.type === 'add-file') {
            this.addNewFile();
            return;
        }
        this.deleteAttachment(command.file);
    }

    onPeopleCommand(command: ShipmentPeopleCommand): void {
        if (this.isCancelledShipment()) return;
        switch (command.type) {
            case 'add-watcher':
                this.addWatcher();
                return;
            case 'send-email':
                this.sendEmail(command.email);
                return;
            case 'call':
                this.makePhoneCall(command.phoneNumber);
                return;
        }
    }

    onNotesCommand(command: ShipmentNotesCommand): void {
        if (this.isCancelledShipment()) return;
        this.shipmentRemarksHtml = command.remarksHtml;
        this.saveShipmentRemarks();
    }

    onRouteCommand(command: ShipmentRouteCommand): void {
        if (this.isCancelledShipment() && command.type !== 'share-waypoint') {
            return;
        }
        switch (command.type) {
            case 'save-order':
                this.saveWaypointOrder();
                return;
            case 'cancel-order':
                this.cancelManualWaypointOrder();
                return;
            case 'optimize':
                this.optimizeWaypoints();
                return;
            case 'start-manual-order':
                this.startManualWaypointOrder();
                return;
            case 'add-driver-home-return':
                this.addReturnWaypointToDriverResidence();
                return;
            case 'open-return-location':
                this.openReturnWaypointLocationDialog();
                return;
            case 'add-first-stop':
                this.openAddWaypointDialog();
                return;
            case 'move-waypoint':
                this.moveWaypoint(command.index, command.direction);
                return;
            case 'share-waypoint':
                this.shareWaypointLocation(command.waypoint);
                return;
            case 'edit-waypoint':
                this.openEditWaypointLocationDialog(command.waypoint);
                return;
            case 'add-waypoint-after':
                this.openAddWaypointDialog(command.waypoint);
                return;
        }
    }

    private applyInvokedStatus(job: ShipmentDelivery): void {
        const updated = {
            ...job,
            jobStatus: ShipmentJobStatus.JOB_INVOKE_DRIVER,
            jobStatusMap: { ...job.jobStatusMap, [ShipmentJobStatus.JOB_INVOKE_DRIVER]: Date.now() }
        } as ShipmentDelivery;
        if (this.shipmentJobMap.has(job.deliveryId)) {
            this.shipmentJobMap.set(job.deliveryId, updated);
            this.orderJobList = Array.from(this.shipmentJobMap.values());
        } else {
            this.orderDeliveryMap.set(job.deliveryId, updated);
            this.orderDeliveryList = Array.from(this.orderDeliveryMap.values());
        }
        this.shipment.deliveries = (this.shipment.deliveries ?? []).map(delivery =>
            delivery.deliveryId === job.deliveryId ? updated : delivery);
        this.cdr.markForCheck();
    }

    private applyConfirmedDelivery(job: ShipmentDelivery, confirmed: ShipmentDelivery): void {
        const updated = {
            ...job, ...confirmed,
            deliveryType: ShipmentDeliveryType.DELIVERY,
            jobStatus: confirmed.jobStatus ?? ShipmentJobStatus.JOB_DRIVER_ACCEPTED,
            jobStatusMap: {
                ...job.jobStatusMap, ...confirmed.jobStatusMap,
                [ShipmentJobStatus.JOB_DRIVER_ACCEPTED]: confirmed.jobStatusMap?.[ShipmentJobStatus.JOB_DRIVER_ACCEPTED] ?? Date.now()
            },
            filesList: confirmed.filesList?.length ? confirmed.filesList : job.filesList ?? [],
            chargeLines: confirmed.chargeLines?.length ? confirmed.chargeLines : job.chargeLines ?? []
        } as ShipmentDelivery;
        this.shipmentJobMap.delete(job.deliveryId);
        this.orderJobList = Array.from(this.shipmentJobMap.values());
        this.orderDeliveryMap.set(job.deliveryId, updated);
        this.orderDeliveryList = Array.from(this.orderDeliveryMap.values());
        this.jobsCount = this.shipmentJobMap.size;
        this.tripsCount = this.orderDeliveryMap.size;
        this.shipment.deliveries = (this.shipment.deliveries ?? []).map(delivery =>
            delivery.deliveryId === job.deliveryId ? updated : delivery);
        this.cdr.markForCheck();
    }

    confirmDriver(orderJob: ShipmentDelivery) {
        if (this.confirmDriverInProgress || !this.isConfirmablePendingJob(orderJob)) return;
        this.confirmDriverInProgress = true;
        this.shipmentService.graduateJobToDelivery(this.shipment.shipmentId, orderJob.deliveryId)
            .pipe(finalize(() => {
                this.confirmDriverInProgress = false;
                this.cdr.markForCheck();
            })).subscribe({
            next: delivery => {
                this.applyConfirmedDelivery(orderJob, delivery);
                this.messageService.add({ severity: 'success', summary: 'Driver confirmed', detail: 'Delivery generated successfully.' });
                this.getOrderQuery(true);
            },
            error: (error) => this.messageService.add({ severity: 'error', summary: 'Confirmation failed', detail: error?.error?.message || 'Could not confirm this delivery.' })
        });
    }

    invokeDrivers(orderJobs: ShipmentDelivery[]) {
        if (this.invokeDriverInProgress) return;
        this.invokeDriverInProgress = true;
        const jobsToInvoke = orderJobs.filter(job => this.isInvocablePendingJob(job));
        if (jobsToInvoke.length === 0) {
            this.messageService.add({ severity: 'info', summary: 'No Drivers to Invoke', detail: 'There are no jobs ready for driver invocation.' });
            this.invokeDriverInProgress = false;
            return;
        }

        const observables = jobsToInvoke.map(job =>
            this.shipmentService.changeDeliveryStatus(this.shipmentId, job.deliveryId, ShipmentJobStatus.JOB_INVOKE_DRIVER)
        );

        forkJoin(observables).pipe(finalize(() => {
            this.invokeDriverInProgress = false;
            this.cdr.markForCheck();
        })).subscribe({
            next: () => {
                jobsToInvoke.forEach(job => this.applyInvokedStatus(job));
                this.messageService.add({ severity: 'success', summary: 'Success', detail: `${jobsToInvoke.length} driver(s) invoked.` });
            },
            error: (error) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while invoking drivers.' });
                this.getOrderQuery(true);
            }
        });
    }

    confirmDrivers(orderJobs: ShipmentDelivery[]) {
        if (this.confirmDriverInProgress) return;
        this.confirmDriverInProgress = true;
        const jobsToConfirm = orderJobs.filter(job => this.isConfirmablePendingJob(job));
        if (jobsToConfirm.length === 0) {
            this.messageService.add({ severity: 'info', summary: 'No Drivers to Confirm', detail: 'There are no jobs ready for driver confirmation.' });
            this.confirmDriverInProgress = false;
            return;
        }

        const observables = jobsToConfirm.map(job =>
            this.shipmentService.graduateJobToDelivery(this.shipment.shipmentId, job.deliveryId)
        );

        forkJoin(observables).pipe(finalize(() => {
            this.confirmDriverInProgress = false;
            this.cdr.markForCheck();
        })).subscribe({
            next: deliveries => {
                deliveries.forEach((delivery, index) => this.applyConfirmedDelivery(jobsToConfirm[index], delivery));
                this.messageService.add({ severity: 'success', summary: 'Success', detail: `${jobsToConfirm.length} driver(s) confirmed.` });
                this.getOrderQuery(true);
            },
            error: (error) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while confirming drivers.' });
                this.getOrderQuery(true);
            }
        });
    }

    addNewChargeLine() {
        this.selectedChargeLine = {
            shipmentId: this.shipmentId,
            deliveryId: undefined,
            buyingChargeAmount: undefined,
            chargeType: undefined,
            remarks: undefined,
            sellingChargeAmount: undefined,
            chargeCurrency: this.shipment.countryOfOrder?.currencyCode ?? 'SAR',
            effectiveDate: new Date().getTime()
        };
        this.chargeLineDialogVisible = true;
    }

    editChargeLine(chargeLine: ShipmentChargeLine) {
        this.selectedChargeLine = { ...chargeLine };
        this.chargeLineDialogVisible = true;
    }

    hideChargeLineDialog() {
        this.chargeLineDialogVisible = false;
    }

    saveChargeLine(request: ShipmentChargeLine | ShipmentChargeLineBulkCreateRequest) {
        this.saveChargeLineInProgress = true;
        if (this.isBulkChargeLineRequest(request)) {
            this.shipmentService.addChargeLines(this.shipmentId, request).subscribe({
                next: savedLines => this.completeChargeLineSave(savedLines, `${savedLines.length} delivery charge lines saved`),
                error: error => this.showChargeLineSaveError(error)
            }).add(() => this.saveChargeLineInProgress = false);
            return;
        }
        this.shipmentService.addOrUpdateChargeLine(this.shipmentId, request).subscribe({
            next: savedChargeLine => this.completeChargeLineSave([savedChargeLine ?? request], 'Charge line saved'),
            error: error => this.showChargeLineSaveError(error)
        }).add(() => this.saveChargeLineInProgress = false);
    }

    private isBulkChargeLineRequest(
        request: ShipmentChargeLine | ShipmentChargeLineBulkCreateRequest
    ): request is ShipmentChargeLineBulkCreateRequest {
        return 'deliveryIds' in request || 'deliveryCharges' in request;
    }

    private completeChargeLineSave(savedLines: ShipmentChargeLine[], detail: string): void {
        for (const lineToSave of savedLines) {
            const index = this.shipment.chargeLines.findIndex(c => c.chargeLineId === lineToSave.chargeLineId);
            if (index !== -1) {
                this.shipment.chargeLines[index] = lineToSave;
            } else {
                this.shipment.chargeLines.push(lineToSave);
            }
        }
        this.recalculateLocalShipmentWorth();
        this.tripCostRefreshKey++;
        this.messageService.add({ severity: 'success', summary: 'Success', detail });
        this.hideChargeLineDialog();
    }

    private showChargeLineSaveError(error: any): void {
        this.messageService.add({
            severity: 'error',
            summary: 'Charge line not saved',
            detail: error?.error?.message || 'Review the charge details and try again.'
        });
    }

    private recalculateLocalShipmentWorth(): void {
        const chargeLines = this.shipment?.chargeLines ?? [];
        this.shipment.totalJobWorth = chargeLines.reduce((sum, line) => sum + (line.buyingChargeAmount ?? 0), 0);
        this.shipment.totalFareQuote = chargeLines.reduce((sum, line) => sum + (line.sellingChargeAmount ?? 0), 0);
    }

    addWatcher() {
        this.selectedWatcher = undefined;
        this.addWatcherDialogVisible = true;
        this.loadWatcherOptions();
    }

    hideAddWatcherDialog(): void {
        if (this.addWatcherInProgress) {
            return;
        }
        this.addWatcherDialogVisible = false;
        this.selectedWatcher = undefined;
    }

    saveWatcher(): void {
        if (!this.shipment?.shipmentId || !this.selectedWatcher) {
            this.messageService.add({ severity: 'warn', summary: 'Watcher required', detail: 'Select a contact to add as watcher.' });
            return;
        }
        if (this.isExistingNominee(this.selectedWatcher.id)) {
            this.messageService.add({ severity: 'info', summary: 'Already added', detail: 'This contact is already connected to the shipment.' });
            return;
        }

        const watcher: ShipmentNomination = {
            isSelf: false,
            haveAccount: Boolean(this.selectedWatcher.firebaseId),
            nominee: this.selectedWatcher,
            client: this.selectedWatcher.company ?? this.shipment.company,
            status: 'NONE',
            role: ShipmentNominationRole.WATCHER
        };
        const nominationPack = {
            sender: this.shipment.nominationPack?.sender,
            receiver: this.shipment.nominationPack?.receiver,
            watchers: [...(this.shipment.nominationPack?.watchers ?? []), watcher]
        } as any;

        this.addWatcherInProgress = true;
        this.shipmentService.saveShipmentNominations(this.shipment.shipmentId, nominationPack).subscribe({
            next: () => {
                this.shipment.nominationPack = nominationPack;
                this.generateAllNominees();
                this.addWatcherDialogVisible = false;
                this.selectedWatcher = undefined;
                this.messageService.add({ severity: 'success', summary: 'Watcher added', detail: `${watcher.nominee.name} is now watching this shipment.` });
                this.cdr.markForCheck();
            },
            error: (error) => {
                this.messageService.add({ severity: 'error', summary: 'Add watcher failed', detail: error?.error?.message || 'Could not add watcher.' });
                this.cdr.markForCheck();
            }
        }).add(() => {
            this.addWatcherInProgress = false;
            this.cdr.markForCheck();
        });
    }

    private loadWatcherOptions(): void {
        const companyIds = [
            this.shipment?.company?.id,
            this.shipment?.customer?.company?.id,
            this.shipment?.sourceLocation?.company?.id,
            this.shipment?.destinationLocation?.company?.id,
            this.sessionStorageService.getCompany()?.id
        ].filter((id): id is number => typeof id === 'number' && id > 0);
        const uniqueCompanyIds = Array.from(new Set(companyIds));
        if (uniqueCompanyIds.length === 0) {
            this.watcherContactOptions = this.fallbackWatcherOptions();
            return;
        }

        this.watcherOptionsLoading = true;
        forkJoin(uniqueCompanyIds.map(companyId => this.customerService.getCustomersByCompany(companyId))).subscribe({
            next: contactGroups => {
                const contacts = contactGroups.flat();
                this.watcherContactOptions = this.uniqueCustomers([...contacts, ...this.fallbackWatcherOptions()])
                    .filter(contact => !this.isExistingNominee(contact.id));
                this.watcherOptionsLoading = false;
                this.cdr.markForCheck();
            },
            error: () => {
                this.watcherContactOptions = this.fallbackWatcherOptions().filter(contact => !this.isExistingNominee(contact.id));
                this.watcherOptionsLoading = false;
                this.messageService.add({ severity: 'warn', summary: 'Contacts limited', detail: 'Could not load all company contacts.' });
                this.cdr.markForCheck();
            }
        });
    }

    private fallbackWatcherOptions(): Customer[] {
        return this.uniqueCustomers([
            this.shipment?.nominationPack?.sender?.nominee,
            this.shipment?.nominationPack?.receiver?.nominee,
            ...(this.shipment?.nominationPack?.watchers ?? []).map(watcher => watcher.nominee)
        ].filter((contact): contact is Customer => Boolean(contact?.id)));
    }

    private uniqueCustomers(customers: Customer[]): Customer[] {
        const seen = new Set<number>();
        return customers.filter(customer => {
            if (!customer?.id || seen.has(customer.id)) {
                return false;
            }
            seen.add(customer.id);
            return true;
        });
    }

    private isExistingNominee(customerId?: number): boolean {
        if (!customerId) {
            return false;
        }
        return this.nominationEntities.some(nomination => nomination.nominee?.id === customerId);
    }

    generateAllNominees() {
        this.nominationEntities = [];
        if (this.shipment?.nominationPack?.sender) {
            this.nominationEntities.push(this.shipment.nominationPack.sender);
        }
        if (this.shipment?.nominationPack?.receiver) {
            this.nominationEntities.push(this.shipment.nominationPack.receiver);
        }
        this.nominationEntities.push(...(this.shipment?.nominationPack?.watchers ?? []));
    }

    sendEmail(email?: string) {
        if (email) {
            window.location.href = `mailto:${email}`;
        } else {
            this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Customer has no email address.' });
        }
    }

    makePhoneCall(phoneNumber?: string) {
        if (phoneNumber) {
            window.location.href = `tel:${phoneNumber}`;
        } else {
            this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Customer has no phone number.' });
        }
    }

    getShortAddress(geoAddress: any): string {
        if (!geoAddress || !geoAddress.addressElements) {
            return '';
        }
        const geoAddressInstance = new GeoAddress().getGeoAddressFromObject(geoAddress);
        return geoAddressInstance.getShortAddress();
    }

    getSeverity(status: string): string {
        switch (status) {
            case 'DRAFT':
                return 'info';
            case 'IN_PROGRESS':
                return 'warn';
            case 'FULFILLED':
                return 'secondary';
            case 'COMPLETED':
                return 'primary';
            case 'INVOICED':
                return 'help';
            case 'CLOSED':
                return 'success';
            case 'CANCELLED':
                return 'danger';
            default:
                return 'secondary';
        }
    }

    getDeliveryFromId(deliveryId?: number): ShipmentDelivery | undefined {
        if (!deliveryId) {
            return undefined;
        }
        return this.orderDeliveryMap.get(deliveryId);
    }

    payloadDescription(item?: PayloadItemView): string {
        return item?.warehouseItemName
            || item?.itemDescription
            || item?.itemDesciption
            || item?.itemType?.name
            || 'Payload';
    }

    payloadSkuLabel(item?: PayloadItemView): string {
        return [item?.warehouseItemNumber, item?.skuNumber, item?.customerItemNumber]
            .filter(Boolean)
            .join(' / ') || '-';
    }

    payloadItemSizeLabel(item?: PayloadItemView): string {
        return item?.itemSize || '-';
    }

    payloadQuantityLabel(item?: PayloadItemView): string {
        if (item?.tenantUomId && item.enteredQuantity != null) {
            return `${item.enteredQuantity} ${item.tenantUomName || 'Tenant UOM'} (${item.itemQuantity?.quantity ?? '-'} ${item.itemQuantity?.uom?.name || 'Each'})`;
        }
        const quantity = item?.itemQuantity?.quantity;
        const unit = item?.itemQuantity?.uom?.name || '';
        return quantity ? `${quantity} ${unit}`.trim() : '-';
    }

    payloadTotalWeightLabel(item?: PayloadItemView): string {
        const totalWeight = Number(item?.itemWeight ?? 0) * Number(item?.itemQuantity?.quantity ?? 0);
        const unit = item?.weightUnit?.shortName || '';
        return totalWeight > 0 ? `${this.formatWeight(totalWeight)} ${unit}`.trim() : 'Weight pending';
    }

    shipmentPayloadWeightSummary(): string {
        const totalsByUnit = new Map<string, number>();
        (this.shipment?.payloadItemList ?? []).forEach(line => {
            const totalWeight = Number(line.itemWeight ?? 0) * Number(line.itemQuantity?.quantity ?? 0);
            const unit = line.weightUnit?.shortName || '';
            if (totalWeight > 0) {
                totalsByUnit.set(unit, (totalsByUnit.get(unit) ?? 0) + totalWeight);
            }
        });
        return [...totalsByUnit.entries()]
            .map(([unit, total]) => `${this.formatWeight(total)} ${unit}`.trim())
            .join(' + ') || 'Weight pending';
    }

    private formatWeight(value: number): string {
        return Number(value.toFixed(3)).toString();
    }

    payloadSourceLabel(item?: PayloadItemView): string {
        const parts = [
            item?.sourceWarehouseLabel,
            item?.sourceZoneLabel,
            item?.conditionLabel
        ].filter(Boolean);
        return parts.join(' / ') || '-';
    }

    payloadMovementLabel(item?: PayloadItemView): string {
        const parts = [
            item?.linkedWarehouseTransferNumber,
            item?.linkedWarehouseDispatchNumber
        ].filter(Boolean);
        return parts.join(' / ') || '-';
    }

    payloadCount(): number {
        return this.shipment?.payloadItemList?.length ?? 0;
    }

    canAmendDelivery(delivery: ShipmentDelivery): boolean {
        if (this.isCancelledShipment()) return false;
        const terminal = ['JOB_DRIVER_CANCELLED', 'JOB_DRIVER_REJECTED', 'DRIVER_JOB_COMPLETED', 'JOB_COMPLETION_ACKNOWLEDGE'];
        const workflow = String(delivery?.workflowState || '').toUpperCase();
        return !!delivery?.deliveryId
            && delivery.deliveryType === ShipmentDeliveryType.DELIVERY
            && !terminal.includes(String(delivery.jobStatus || '').toUpperCase())
            && !['CANCELLED', 'DELIVERY_COMPLETE', 'CUSTOMER_ACKNOWLEDGED'].includes(workflow);
    }

    hasNoDeliveryAssignments(): boolean {
        return this.orderJobList.length === 0 && this.orderDeliveryList.length === 0;
    }

    canAddOrderReleasesToShipment(): boolean {
        return !!this.shipmentId && !this.isCancelledShipment() && this.hasNoDeliveryAssignments()
            && this.permissionService.hasPermission(app_permissions.shipments.deliveries.edit);
    }

    canAssignDriverVehicleFromCommandCentre(): boolean {
        if (!this.shipmentId || this.isCancelledShipment() || !this.permissionService.hasPermission(app_permissions.shipments.deliveries.assign)) return false;
        const assignedOrPending = this.orderJobList.length + this.orderDeliveryList.length;
        const requested = this.shipment?.quantityRequired || 0;
        // Pending jobs are already assignments.  Counting only confirmed deliveries
        // kept “Assign Driver/Vehicle” visible when every requested truck was
        // already selected and the next valid action was Invoke or Confirm.
        return assignedOrPending === 0 || requested > assignedOrPending;
    }

    canInvokeAnyPendingJob(): boolean {
        if (this.isCancelledShipment()) return false;
        return this.canRunPendingDispatchAction(app_permissions.shipments.deliveries.invoke)
            && this.dispatchAssignments().some(job => this.isInvocablePendingJob(job));
    }

    canConfirmAnyPendingJob(): boolean {
        if (this.isCancelledShipment()) return false;
        return this.canRunPendingDispatchAction(app_permissions.shipments.deliveries.confirm)
            && this.dispatchAssignments().some(job => this.isConfirmablePendingJob(job));
    }

    /**
     * Invoke/confirm were added after the established delivery-assignment
     * permission. Existing dispatch roles (including Portal Administrator) may
     * legitimately have assignment access but not the newer individual codes.
     * Keep those roles operating while still honoring either dedicated code.
     */
    private canRunPendingDispatchAction(actionPermission: string): boolean {
        return this.permissionService.hasPermission(actionPermission)
            || this.permissionService.hasPermission(app_permissions.shipments.deliveries.assign);
    }

    /**
     * Planning can create a DELIVERY immediately (rather than a draft JOB).
     * Until it reaches JOB_DRIVER_ACCEPTED it is still a dispatch assignment,
     * so it must retain the same invoke/confirm controls as a draft job.
     */
    private dispatchAssignments(): ShipmentDelivery[] {
        return [...this.orderJobList, ...this.orderDeliveryList];
    }

    private isInvocablePendingJob(job: ShipmentDelivery): boolean {
        // A job may already have a dispatcher-selected driver.  Invocation is still
        // valid in that case (it sends the work to that driver); requiring an empty
        // driver here made a selected job impossible to advance from Selecting
        // Vehicle.
        return !!job?.deliveryId
            && [ShipmentJobStatus.JOB_DETAILS_ENTRY, ShipmentJobStatus.SEARCHING_VEHICLE,
                ShipmentJobStatus.SELECTING_VEHICLE].includes(job.jobStatus as ShipmentJobStatus);
    }

    private isConfirmablePendingJob(job: ShipmentDelivery): boolean {
        return !!job?.deliveryId && !!job.deliveryDriver
            && [ShipmentJobStatus.SELECTING_VEHICLE, ShipmentJobStatus.JOB_INVOKE_DRIVER, ShipmentJobStatus.JOB_DRIVER_NEGOTIATING,
                ShipmentJobStatus.JOB_ADVERTISE_INVOKE].includes(job.jobStatus as ShipmentJobStatus);
    }

    openShipmentReleaseAttachment(): void {
        if (!this.canAddOrderReleasesToShipment()) return;
        this.openReleaseSelection();
    }

    openReleaseAmendment(delivery: ShipmentDelivery): void {
        if (!this.canAmendDelivery(delivery) || !this.shipmentId) return;
        this.openReleaseSelection(delivery);
    }

    private openReleaseSelection(delivery?: ShipmentDelivery): void {
        if (!this.shipmentId) {
            this.messageService.add({ severity: 'warn', summary: 'Company unavailable', detail: 'The shipment owning company is required to load Release Pool records.' });
            return;
        }
        this.selectedDeliveryForAmendment = delivery;
        this.shipmentReleaseMode = !delivery;
        this.releaseAmendmentStep = 1;
        this.releasePool = [];
        this.releaseSearch = '';
        this.releasePage = 0;
        this.releasePoolError = '';
        this.selectedReleaseIds = [];
        this.releaseAmendmentPreview = undefined;
        this.shipmentAttachmentPreview = undefined;
        this.releaseAmendmentHistory = [];
        this.releaseAmendmentReason = '';
        this.releaseAmendmentBuyingPrice = undefined;
        this.releaseAmendmentSellingPrice = undefined;
        this.releaseAmendmentDialogVisible = true;
        this.loadReleaseCandidates(0);
        if (delivery) this.loadReleaseAmendmentHistory(delivery);
    }

    private loadReleaseCandidates(page: number): void {
        this.releaseAmendmentLoading = true;
        this.releasePoolError = '';
        this.shipmentService.getOrderReleaseCandidates(this.shipmentId,
            this.selectedDeliveryForAmendment?.deliveryId, this.releaseSearch, page).pipe(finalize(() => {
            this.releaseAmendmentLoading = false;
            this.cdr.markForCheck();
        })).subscribe({
            next: response => {
                this.releasePool = response.items ?? [];
                this.releasePage = response.page;
                this.releaseTotalPages = response.totalPages;
                this.releaseTotal = response.totalElements;
            },
            error: error => {
                this.releasePool = [];
                this.releasePoolError = error?.error?.message || 'Could not load ready order releases.';
            }
        });
    }

    closeReleaseAmendment(): void {
        if (this.releaseAmendmentApplying) return;
        this.releaseAmendmentDialogVisible = false;
        this.shipmentReleaseMode = false;
        this.cdr.markForCheck();
    }

    isReleaseSelected(releaseId?: number): boolean {
        return !!releaseId && this.selectedReleaseIds.includes(releaseId);
    }

    toggleRelease(releaseId?: number): void {
        if (!releaseId) return;
        this.selectedReleaseIds = this.isReleaseSelected(releaseId)
            ? this.selectedReleaseIds.filter(id => id !== releaseId)
            : [...this.selectedReleaseIds, releaseId];
    }

    previewReleaseAmendment(): void {
        const delivery = this.selectedDeliveryForAmendment;
        if (!delivery?.deliveryId || this.selectedReleaseIds.length === 0) {
            this.messageService.add({ severity: 'warn', summary: 'Select releases', detail: 'Select at least one ready release before previewing the amendment.' });
            return;
        }
        this.releaseAmendmentLoading = true;
        this.shipmentService.previewDeliveryReleaseAmendment(this.shipmentId, delivery.deliveryId, {
            releaseIds: this.selectedReleaseIds,
            actorCustomerId: this.sessionStorageService.getCustomer()?.id
        }).pipe(finalize(() => {
            this.releaseAmendmentLoading = false;
            this.cdr.markForCheck();
        })).subscribe({
            next: preview => {
                this.releaseAmendmentPreview = preview;
                this.releaseAmendmentBuyingPrice = preview.prices?.proposedBuyingPrice;
                this.releaseAmendmentSellingPrice = preview.prices?.proposedSellingPrice;
                this.releaseAmendmentStep = 2;
            },
            error: error => this.messageService.add({ severity: 'error', summary: 'Route cannot be amended', detail: error?.error?.message || 'The selected releases are no longer eligible.' })
        });
    }

    attachOrderReleasesToShipment(): void {
        if (!this.shipmentReleaseMode || !this.canAddOrderReleasesToShipment() || this.selectedReleaseIds.length === 0) {
            this.messageService.add({ severity: 'warn', summary: 'Select releases', detail: 'Select at least one ready release before adding it to the shipment.' });
            return;
        }
        this.releaseAmendmentLoading = true;
        this.shipmentService.previewOrderReleaseAttachment(this.shipmentId, {
            releaseIds: this.selectedReleaseIds,
            actorCustomerId: this.sessionStorageService.getCustomer()?.id
        }).pipe(finalize(() => {
            this.releaseAmendmentLoading = false;
            this.cdr.markForCheck();
        })).subscribe({
            next: preview => {
                this.shipmentAttachmentPreview = preview;
                this.releaseAmendmentStep = 2;
            },
            error: error => this.messageService.add({
                severity: 'error', summary: 'Attachment preview failed',
                detail: error?.error?.message || 'Review the release eligibility and try again.'
            })
        });
    }

    applyOrderReleaseAttachment(): void {
        const preview = this.shipmentAttachmentPreview;
        if (!preview?.attachmentId) return;
        this.releaseAmendmentApplying = true;
        this.shipmentService.applyOrderReleaseAttachment(this.shipmentId, preview.attachmentId,
            !!preview.requiresZeroSellConversion).pipe(finalize(() => {
            this.releaseAmendmentApplying = false;
            this.cdr.markForCheck();
        })).subscribe({
            next: result => {
                this.messageService.add({ severity: 'success', summary: 'Order releases added',
                    detail: `${result.releaseIds.length} release(s) linked to the shipment.` });
                this.closeReleaseAmendment();
                this.getOrderQuery();
            },
            error: error => this.messageService.add({ severity: 'error', summary: 'Attachment failed',
                detail: error?.error?.message || 'Review the releases and try again.' })
        });
    }

    moveReleaseAmendmentToConfirmation(): void {
        if (!this.releaseAmendmentPreview && !this.shipmentAttachmentPreview) return;
        this.releaseAmendmentStep = 3;
        this.cdr.markForCheck();
    }

    applyReleaseAmendment(): void {
        if (!this.permissionService.hasPermission(app_permissions.shipments.deliveries.edit)) {
            this.messageService.add({ severity: 'error', summary: 'Edit permission required', detail: 'You can review releases and the route, but an authorized dispatcher must apply the amendment.' });
            return;
        }
        const delivery = this.selectedDeliveryForAmendment;
        const preview = this.releaseAmendmentPreview;
        if (!delivery?.deliveryId || !preview?.amendmentId || !this.releaseAmendmentReason.trim()
            || this.releaseAmendmentBuyingPrice == null || this.releaseAmendmentSellingPrice == null) {
            this.messageService.add({ severity: 'warn', summary: 'Confirmation required', detail: 'Enter an amendment reason and confirm both revised prices.' });
            return;
        }
        this.releaseAmendmentApplying = true;
        this.shipmentService.applyDeliveryReleaseAmendment(this.shipmentId, delivery.deliveryId, preview.amendmentId, {
            reason: this.releaseAmendmentReason.trim(),
            confirmedBuyingPrice: Number(this.releaseAmendmentBuyingPrice),
            confirmedSellingPrice: Number(this.releaseAmendmentSellingPrice),
            confirmZeroSellConversion: !!preview.requiresZeroSellConversion,
            actorCustomerId: this.sessionStorageService.getCustomer()?.id
        }).pipe(finalize(() => {
            this.releaseAmendmentApplying = false;
            this.cdr.markForCheck();
        })).subscribe({
            next: amendment => {
                this.releaseAmendmentPreview = amendment;
                this.loadReleaseAmendmentHistory(delivery);
                if (amendment.status === 'COMPLIANCE_PENDING') {
                    this.messageService.add({ severity: 'warn', summary: 'Bayan reissue pending', detail: amendment.bayanError || 'Pickup is blocked until the replacement waybill is ready.' });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Delivery amended', detail: 'Releases, route, payload, and approved prices were updated. The driver app will refresh.' });
                this.closeReleaseAmendment();
                this.getOrderQuery();
            },
            error: error => this.messageService.add({ severity: 'error', summary: 'Amendment was not applied', detail: error?.error?.message || 'Review the route again and retry.' })
        });
    }

    retryReleaseAmendmentBayan(amendment: ShipmentDeliveryReleaseAmendment): void {
        const delivery = this.selectedDeliveryForAmendment;
        if (!delivery?.deliveryId || !amendment?.amendmentId) return;
        this.releaseAmendmentApplying = true;
        this.shipmentService.retryDeliveryReleaseAmendmentBayan(this.shipmentId, delivery.deliveryId, amendment.amendmentId)
            .pipe(finalize(() => {
                this.releaseAmendmentApplying = false;
                this.cdr.markForCheck();
            })).subscribe({
                next: result => {
                    this.releaseAmendmentPreview = result;
                    this.loadReleaseAmendmentHistory(delivery);
                    if (result.status === 'COMPLETED') {
                        this.messageService.add({ severity: 'success', summary: 'Replacement waybill ready', detail: 'The driver can resume the amended delivery.' });
                        this.getOrderQuery();
                    } else {
                        this.messageService.add({ severity: 'warn', summary: 'Bayan still pending', detail: result.bayanError || 'Try reconciliation again after Bayan is available.' });
                    }
                },
                error: error => this.messageService.add({ severity: 'error', summary: 'Retry failed', detail: error?.error?.message || 'Could not retry the replacement waybill.' })
            });
    }

    private loadReleaseAmendmentHistory(delivery: ShipmentDelivery): void {
        if (!delivery?.deliveryId) return;
        this.shipmentService.getDeliveryReleaseAmendments(this.shipmentId, delivery.deliveryId).subscribe({
            next: history => {
                this.releaseAmendmentHistory = history ?? [];
                this.cdr.markForCheck();
            },
            error: () => this.releaseAmendmentHistory = []
        });
    }

    canPostToAccounts(): boolean {
        return ['COMPLETED', 'POSTED_TO_ACCOUNTS'].includes(String(this.shipment?.shipmentStatus))
            && this.permissionService.hasPermission(app_permissions.shipments.finance.post);
    }

    canCorrectBillToParty(): boolean {
        return !!this.shipment?.shipmentId
            && !this.isZeroSellConsolidation()
            && !['POSTED_TO_ACCOUNTS', 'INVOICED', 'CLOSED', 'CANCELLED'].includes(this.shipment.shipmentStatus)
            && this.permissionService.hasPermission(app_permissions.shipments.party_correct);
    }

    canCorrectSchedule(): boolean {
        return !!this.shipment?.shipmentId
            && !['POSTED_TO_ACCOUNTS', 'INVOICED', 'CLOSED', 'CANCELLED'].includes(this.shipment.shipmentStatus)
            && this.permissionService.hasPermission(app_permissions.shipments.edit);
    }

    openScheduleCorrection(): void {
        if (this.canCorrectSchedule()) this.scheduleCorrectionDialog?.open();
    }

    onScheduleCorrected(): void {
        this.messageService.add({ severity: 'success', summary: 'Shipment dates updated',
            detail: 'Matching planned stop times were updated. Actual event times were preserved.' });
        this.getOrderQuery();
    }

    openBillToPartyCorrection(): void {
        if (this.canCorrectBillToParty()) this.partyCorrectionDialog?.open();
    }

    onBillToPartyCorrected(): void {
        this.messageService.add({ severity: 'success', summary: 'Bill-to party corrected',
            detail: 'The shipment now uses the selected CRM party.' });
        this.getOrderQuery();
    }

    postToAccounts(): void {
        if (!this.canPostToAccounts() || this.postingToAccounts) {
            return;
        }
        this.accountsReviewVisible = true;
    }

    confirmAccountsPost(): void {
        if (!this.accountsReviewVisible || this.postingToAccounts) return;
                this.postingToAccounts = true;
                this.shipmentService.postShipmentToAccounts(this.shipmentId)
                    .pipe(finalize(() => {
                        this.postingToAccounts = false;
                        this.cdr.markForCheck();
                    }))
                    .subscribe({
                        next: result => {
                            this.accountsPostingResult = result;
                            this.accountsReviewVisible = false;
                            this.shipment.shipmentStatus = result.shipmentStatus as any;
                            this.shipment.workflowState = result.shipmentStatus;
                            this.messageService.add({
                                severity: 'success',
                                summary: this.localeService.translate('pages.shipmentDetail.actions.postToAccountsSuccess'),
                                detail: this.localeService.translate('pages.shipmentDetail.actions.postToAccountsSummary', {
                                    bulkCosts: result.bulkCostIds?.length ?? 0,
                                    receivables: result.receivableIds?.length ?? 0,
                                    payables: result.payableIds?.length ?? 0
                                }),
                                life: 8000
                            });
                            if (result.channelOutcomes?.['FINANCE_RECONCILIATION']) {
                                this.messageService.add({ severity: 'warn', summary: 'Finance reconciliation',
                                    detail: result.channelOutcomes['FINANCE_RECONCILIATION'], life: 12000 });
                            }
                            this.getOrderQuery();
                        },
                        error: error => this.messageService.add({
                            severity: 'error',
                            summary: this.localeService.translate('pages.shipmentDetail.actions.postToAccountsError'),
                            detail: error?.error?.message || error?.message
                                || this.localeService.translate('pages.shipmentDetail.actions.postToAccountsRetry')
                        })
                    });
    }

    cancelShipment() {
        this.confirmationService.confirm({
            message: 'Do you want to cancel this shipment? This action cannot be undone. All active deliveries will also be cancelled automatically.',
            header: 'Cancel Shipment',
            icon: 'fa-solid fa-ban',
            accept: () => {
                const cancellableDeliveries = this.getCancellableDeliveries();
                const cancelOps = cancellableDeliveries.map(delivery =>
                    this.shipmentService.cancelDelivery(this.shipmentId, delivery.deliveryId, {
                        reason: 'Shipment cancelled',
                        actorCustomerId: this.sessionStorageService.getCustomer()?.id
                    }).pipe(
                        catchError(err => {
                            console.warn(`Failed to auto-cancel delivery ${delivery.deliveryId}`, err);
                            return of(null);
                        })
                    )
                );

                const performCancel = cancelOps.length > 0
                    ? forkJoin(cancelOps).pipe(
                        switchMap(() => this.shipmentService.changeShipmentStatus(this.shipmentId, 'CANCELLED'))
                    )
                    : this.shipmentService.changeShipmentStatus(this.shipmentId, 'CANCELLED');

                performCancel.subscribe({
                    next: () => {
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Confirmed',
                            detail: cancellableDeliveries.length > 0
                                ? 'Shipment and all associated deliveries cancelled successfully'
                                : 'Shipment cancelled successfully'
                        });
                        this.getOrderQuery(); // Refresh shipment data to reflect cancelled status
                    },
                    error: (err: any) => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to cancel shipment: ' + (err.error?.message || err.message)
                        });
                    }
                });
            },
            reject: (type: ConfirmEventType) => {
                switch (type) {
                    case ConfirmEventType.REJECT:
                        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected to cancel the shipment' });
                        break;
                    case ConfirmEventType.CANCEL:
                        this.messageService.add({ severity: 'warn', summary: 'Cancelled', detail: 'You have cancelled the operation' });
                        break;
                }
            }
        });
    }

}
